export default {
  language: 'Bahasa',
  switchlangtip: 'Perubahan bahasa telah berhasi',
  nav: {
    // app.vue左侧导航栏
    singeltest: 'Tes tunggal',
    ai_call: 'AI Calling',
    calling_operation: 'Operasi calling',
    robot: 'Manajemen Robot',
    black_list: 'Daftar Hitam (Blacklist)',
    robot_list: 'Daftar Robot',
    add_call: 'Add Call',
    systemsettings: 'Sistem Settings',
    accountmanagement: 'Manajemen akun',
    corporateaccountinformation: 'Detail akun perusahaan',
    usermanagement: 'User',
    functionrightsrole: 'Akses peran',
    dashboard: 'Dasbor',
    promote: 'Promo',
    callcenter: 'Calling center',
    executecall: 'Tugas Panggilan',
    detailsofcall: 'Detail Panggilan',
    reportstatistics: 'Laporan statistik',
    overallreportstatistics: 'Laporan statistik keseluruhan',
    speechreportstatistics: 'Laporan statistik ucapan',
    accountreportstatistics: 'Laporan statistik akun',
    robotreportstatistics: 'Laporan statistik robot',
    archivingcenter: 'Pusat arsip',
    historicaltaskrecord: 'Riwayat tugas',
    historicalcalllog: 'Riwayat panggilan',
    detailsofcharges: 'Rincian biaya',
    testcall: 'Tes',
    guide: 'Panduan',
    strategy: 'Strategi Panggilan',
    plan: 'Rencana',
    auditInformation: 'AuditInformation',
    PDetails: 'PDetails',
    PStrategy: 'PStrategy',
    PPlans: 'PPlans',
    ICDetail: '信审详情',
    ICStrategy: '信审呼叫策略',
    ICPlan: '信审计划任务',
    accessControl: 'Kontrol Akses'
  },
  global: {
    date: 'Silakan pilih tanggal',
    taskNameSelector: {
      selectLabel: 'Pemilihan tugas',
      selectTask: 'Silakan pilih nama tugas',
      selectTest: 'Silakan pilih nama tugas tes',
      allSelect: 'Pilih semua tugas',
      selectWarn: 'Silakan pilih minimal satu tugas dan kemudian permintaan'
    },
    planNameSelector: {
      selectLabel: 'Rencana',
      selectTask: 'Silakan pilih nama tugas',
      selectTest: 'Silakan pilih nama rencana tes',
      allSelect: 'Pilih semua tugas',
      selectWarn: 'Silakan pilih minimal satu tugas sebelum membuat kueri'
    },
    distinctSelector: {
      label: 'De-duplikasi',
      placeholder: 'Silakan pilih De-duplikasi'
    },
    select: 'Pilih',
    // filter: 'Cari',
    MarketingA: 'A: Tertarik',
    MarketingB: 'B: Tidak tertarik',
    query: 'Cari',
    filter: 'Saring',
    today: 'Hari ini',
    yesterday: 'Kemarin',
    nearly_three_day: '3 hari terakhir',
    nearly_seven_day: '7 hari terakhir',
    nearly_thirty_day: '30 hari terakhir',
    nearly_days: '{num} hari terakhir',
    startTime: 'waktu mulai',
    endTime: 'waktu selesai',
    batchDel: 'Hapus Batch',
    telNumber: 'Nomor telepon',
    triggerTime: 'Waktu pemicu',
    intention: 'Intention',
    sort: 'Pengurutan',
    setSort: 'Ubah Pengurutan',
    showName: 'Tampilan Nama',
    totals: 'Jumlah Total',
    rounds: 'Putaran',
    splitStr: ' ',
    vs: 'vs.',
    processStatus: 'Status Pemrosesan',
    pending: 'Pending',
    processing: 'Sedang Diproses',
    finished: 'Selesai',
    toSelect: 'Pilih',
    editSelect: 'Ubah Pilihan',
    other: 'Lainnya'
  },
  menuNode: {
    CallTasks: 'Tugas Panggilan',
    CallPlans: 'Rencana Panggilan',
    CallStrategy: 'Strategi Panggilan',
    CallDetails: 'Detail Panggilan',
    ICDetail: 'IC Detail',
    BlackList: ' Blacklist',
    RobotList: 'Daftar Robot',
    SingleTest: 'Tes tunggal',
    AddCall: 'Penambahan Telepon',
    Corporate: 'Detail akun perusahaan',
    UserControl: 'User',
    accountSafe: 'Manajemen Keamanan Akun',
    RolePermission: 'Peran akses',
    Dashboard: 'Dasbor',
    AiCalling: 'AI Calling',
    RobotManage: 'Manajemen Robot',
    CallingOperation: 'Operasi panggilan',
    Inbound: 'Masuk',
    AccountManage: 'Manajemen akun',
    personalInfo: 'Data Pribadi',
    systemsettings: 'Pengaturan sistem',
    collection: 'Layanan koleksi',
    marketing: 'Layanan pemasaran',
    info_check: 'Layanan survei',
    outbound: 'Layanan panggilan keluar',
    operationOutbound: 'Operasi panggilan  keluar',
    pack_up_menu: 'Tutup menu',
    switch_old_version: 'Beralih ke versi lama',
    switch_new_version: 'Beralih versi baru',
    prompt_cannot_used: 'Akun Anda dibuat di versi baru, jadi tidak dapat digunakan di versi lama',
    personalSetting: 'Pengaturan Pribadi',
    loginInfo: 'Informasi Login',
    template: 'Trial version',
    RobotExperience: 'Trial Robot',
    servise_tools: 'Layanan dan Pengaturan',
    helpCenter: 'Pusat Bantuan',
    OperatingRecord: 'Catatan operasi',
    CallAssistant: 'Asisten panggilan',
    releaseNotes: 'Catatan versi',
    cod: 'E-commerce',
    WorkflowManger: 'Manajemen workflow',
    WorkflowTemplate: 'Template Alur Kerja',
    Workflow: 'Tugas workflow',
    SmsTemplate: 'Manajemen template SMS',
    WhatsappTemplate: 'Manajemen Template WhatsApp',
    MultiChannelManager: 'Manajemen multi-saluran',
    StageReport: 'Laporan Berkala',
    CrossLogin: 'Meniru',
    manual: 'Panduan Penggunaan',
    document: 'Dokumen API',
    add: 'Tambahkan',
    info: 'Lihat Rincian',
    copy: 'Salinan',
    edit: 'Edit',
    child: 'Lihat subtugas',
    check: 'Lihat proses',
    view: 'Data overview',
    editRole: 'Edit peran',
    addRole: 'Tambahkan peran',
    version: 'manajemen versi',
    batchShare: 'Bagikan',
    shareLog: 'Bagikan Riwayat',
    viewData: 'Lihat Data',
    Application: 'Pasar Aplikasi',
    CallDetailAudioDownload: 'Unduh Rekaman di halaman Detail Panggilan',
    TaskDetailAudioDownload: 'Unduh Rekaman di halaman Tugas Panggilan',
    PlanViewAudioDownload: 'Unduh Rekaman di halaman Rencana Panggilan',
    ViewCallDetail: 'Lihat Dialog',
    Tools: 'Layanan dan Pengaturan',
    WorkflowVersion: 'manajemen versi',
    CallLog: 'Riwayat Panggilan',
    chatbot: 'Chatbot',
    ChatbotOverview: '数据概览',
    ChatbotLiveMonitor: '实时视图',
    ChatbotAnalysis: '机器人分析',
    ChatbotCR: '会话记录',
    ChatbotSocial: '消息渠道',
    ChatbotManage: '机器人管理',
    ChatbotOnline: '机器人上线',
    ChatbotReq: '请求信息',
    ChatbotWBTmpl: 'WA模版管理',
    ChatbotWBTmplDetail: '模版详情',
    ChatbotWBTmplAdd: '新增模版',
    ChatbotWBTmplEdit: '编辑模版',
    ChatbotChat: '聊天',
    ChatbotTeamInbox: '在线聊天',
    ChatbotMAB: '广播营销',
    ChatbotBroadcast: '广播列表',
    ChatbotGeneral: '通用',
    ChatbotAPI: 'API文档',
    ChatbotOptOut: 'Opt-out列表',
    InboundRobotManage: 'Manajemen Robot',
    InboundDashboard: 'Dashboard',
    InboundCallRecords: 'Riwayat Panggilan',
    timeTip: 'Pertanyaan data online terbatas hanya pada 6 bulan terakhir.',
    timeTip2: 'Hanya mendukung kueri online untuk data 6 bulan terakhir mulai dari tanggal 1 Maret 2024.',
    workflowTip: 'Metode ini hanya dapat digunakan untuk permintaan yang dibuat setelah 1 Februari 2024.',
    configCenter: 'Pusat Konfigurasi',
    accessControl: 'Kontrol Akses',
    webhook: 'Konfigurasi Callback',
    holiday: 'Manajemen Kalender',
    Insights: '仪盘表',
    ChatbotInsights: '仪盘表',
    ChatbotInsightsLiveMonitor: '实时视图',
    ChatbotHistorical: '历史看板',
    ChatbotInsightsRecord: '历史看板'
  },
  account: {
    // 账户管理
    account_time_zone_new: 'Wilayah akun dan zona waktu',
    cod: 'E-commerce',
    template: 'Trial version',
    administrator: 'Administrator',
    enterprise: 'Aliansi perusahaan',
    account_title: 'Nama akun',
    account_country: 'Negara',
    account_time_zone: 'Zona waktu',
    account_id: 'ID akun',
    corporate_contacts: 'Kontak perusahaan',
    contact: 'Nama kontak',
    email: 'Alamat email',
    phone: 'Nomor telepon',
    gender: 'Jenis kelamin',
    male: 'Pria',
    female: 'Wanita',
    user_group: 'Group pengguna',
    add_uer: 'Tambahkan user',
    edit_uer: 'Edit user',
    edit_group: 'Edit grup',
    add_group: 'Add grup',
    group_name: 'Nama Grup ',
    user_name: 'Name',
    first_name: 'Nama Depan',
    last_name: 'Nama Belakang',
    account_number: 'Login akun',
    password: 'Kata sandi',
    initial_password: 'Kata sandi awal',
    roleId: 'ID Peran',
    lastLoginTime: 'Waktu Login Terakhir',
    group: 'Nama grup ',
    role: 'Nama Karakter',
    edit: 'Edit',
    added: 'Tambahan',
    enable: 'Aktif',
    disable: 'Nonaktif',
    save: 'Simpan',
    reset_passwords: 'Reset Password',
    new_login_password: 'Sandi baru',
    set_new_login_password: 'Ganti kata sandi',
    error_user_tip: 'Risiko telah terdeteksi di akun Anda. Demi keamanan akun Anda, silakan ubah kata sandi login Anda.',
    new_user_tip: 'Demi keamanan akun Anda, silakan ubah kata sandi login Anda.',
    confirm_password: 'Konfirmasi sandi',
    add_role: 'Tambahkan peran',
    edit_role: 'Edit peran',
    role_name: 'Nama Karakter',
    role_describe: 'Deskripsi ',
    actions: 'Operasi',
    status: 'Status',
    delete: 'Menghapus',
    basic_information: 'Informasi dasar',
    business_type: 'Jenis bisnis',
    fnction_permissions: 'Fungsi akses',
    data_permission: 'Akses data',
    collection: 'layanan koleksi',
    marketing: 'layanan pemasaran',
    info_check: 'Check info',
    CallingOperation: 'operasi panggilan',
    chatbot: 'Chatbot',
    select_all: 'Pilih semua',
    clear: 'Hapus',
    all: 'Semua',
    prompt_account_name: 'Silakan masukkan akun dan nama',
    prompt_password_again: 'Silakan masukkan kata sandi lagi',
    prompt_role_description: 'Silakan masukkan deskripsi peran',
    prompt_first_name: 'Silahkan masukkan nama',
    prompt_last_name: 'Silahkan masukkan nama belakang',
    prompt_login: 'Silahkan masukkan akun',
    prompt_password: 'Kata sandi harus lebih dari 8-16angka,huruf kapital dan huruf kecil',
    prompt_logo: 'Bisa mengunggah dalam bentuk jpg/jpeg/png/gif,tidak lebih dari 5M',
    prompt_group: 'Silakan pilih grup',
    prompt_role: 'Silakan pilih karakter',
    prompt_role_name: 'Silakan masukkan nama karakter',
    prompt_delete_role: 'Karakter sudah dikaitkan dengan pengguna, tidak dapat dihapus',
    error_logo_type: 'Hanya bisa mengunggah gambar dalam bentuk jpg/jpeg/png/gif',
    error_logo_size: 'Ukuran logo tidak boleh lebih dari 5M',
    error_cannot_exceed_200: 'Tidak boleh lebih dari 200 huruf',
    error_cannot_exceed_100: 'Tidak boleh lebih dari 100 huruf',
    error_cannot_exceed_50: 'Tidak boleh lebih dari 50 huruf',
    error_cannot_exceed_20: 'Tidak boleh lebih dari 20 huruf',
    error_group: 'Ada pengguna dalam grup ini, tidak dapat dihapus',
    error_group_size: 'Tidak lebih dari 50 grup',
    error_login: 'Akun tidak boleh kosong',
    error_login_exis: 'Nama akun sudah ada',
    error_password: 'Kata sandi harus lebih dari 8-16 angka,huruf kapital dan huruf kecil',
    error_password_different: 'kata sandi yang dimasukkan tidak sama',
    error_group_name: 'Nama grup tidak boleh terulang',
    error_enable: 'Status pengguna diaktifkan jumlah akun tidak boleh lebih dari{xxx}',
    error_role_name: 'Nama karakter tidak boleh kosong',
    error_business_type: 'Jenis layanan tidak boleh kosong',
    error_first_name: 'Silahkan masukkan nama depan',
    error_last_name: 'Silahkan masukkan nama belakang',
    error_enter_group_name: 'Nama grup tidak boleh kosong',
    error_new_login_password: 'Kata sandi baru tidak boleh kosong',
    error_confirm_password: 'Masukkan kembali kata sandi',
    permission_list: {
      view: 'Lihat',
      add: 'Tambahkan',
      edit: 'Edit',
      start: 'Mulai',
      delete: 'Menghapus',
      pause: 'Berhenti/Pemulihan',
      cancel: 'Batal',
      download: 'Unduh',
      copy: 'Salinan',
      enable: 'Aktif',
      disable: 'Nonaktif',
      ableOrNot: 'Nonaktif/Aktif',
      viewShield: 'Lihat data yang diblokir',
      allocation: 'Assign',
      download_task: 'Unduh tugas',
      download_roll: 'Unduh nomor panggilan',
      download_detail: 'Unduh detail',
      password: 'Reset Password',
      apply: 'Terapkan',
      edit_remark: 'Edit Catatan Tambahan',
      edit_name: 'Mengubah nama template',
      download_subtask: 'Downlaod catatan subtugas',
      view_subtask_detail: 'Lihat detail subtugas',
      view_subtask: 'Lihat subtugas',
      add_detail: 'Penambahkan daftar',
      workflowProgress: 'Lihat proses',
      triggerImmediately: 'Memicu segera',
      categorize: 'Pengelompokkan Event Labels',
      RobotExperience: 'Trial Robot',
      StageReport: 'Laporan Berkala',
      CrossLogin: 'Meniru',
      MultiChannelManager: 'Manajemen multi-saluran',
      releaseNotes: 'Catatan versi',
      operateWord: 'Panduan Penggunaan',
      apiWord: 'Dokumen API',
      OperatingRecord: 'Catatan operasi',
      Application: 'Pasar Aplikasi',
      view_number: 'Nomor Telepon dalam Teks Biasa',
      selectCountry: 'Pilih Negara',
      processProportion: 'Distribusi Proses Bot',
      labelDistribution: 'Distribusi Tujuan',
      transRateTrends: 'Spread Panggilan & Transfer',
      transCauseDistribution: 'Distribusi Penyebab Transfer ke Agen',
      effectKnowledge: 'Persentase Pengetahuan yang Valid',
      knowledgeHitRatio: 'Tingkat Hit Pengetahuan',
      hotKnowledge: '10 Pengetahuan Paling Populer',
      unpopularKnowledge: '20 Pengetahuan Paling Tidak Populer',
      callDimension: 'Overview Panggilan',
      robotCalls: 'Jumlah Panggilan',
      robotCallsProgress: 'Panggilan Robot yang Sedang Berlangsung',
      successfulTransferRate: 'Tingkat Keberhasilan Transfer ',
      arCallDuration: 'Rata-rata Durasi Panggilan Robot ',
      arInteractionRounds: 'Rata-rata Putaran Interaksi Robot ',
      agentCalls: 'Panggilan Agen',
      agentCallsProgress: 'Panggilan Agen yang Sedang Berlangsung',
      aTransferRate: 'Tingkat Transfer yang Dilakukan',
      taCallDuration: 'Rata-Rata Total Durasi Panggilan ',
      knowledgeDimension: 'Poin Pengetahuan',
      downRecording: 'Unduh rekaman',
      downRecord: 'Unduh',
      approvalAddTask: 'Persetujuan - Tugas Baru',
      approvalDownloadList: 'Persetujuan - Unduh Daftar',
      approvalApprove: 'Persetujuan - Setujui',
      approvalAddPlan: 'Setujui - Rencana Baru',
      approvalDownloadPlanList: 'Persetujuan - Unduh Daftar',
      approvalPlanApprove: 'Persetujuan - Setujui',
      ViewCallDetail: 'Lihat Dialog',
      Dashboard: 'Dasbor',
      AccountManage: 'Manajemen akun',
      ModifyTimeZone: 'Ubah Zona Waktu',
      Corporate: 'Detail akun perusahaan',
      RolePermission: 'Akses peran',
      AiCalling: 'AI Calling',
      CallTasks: 'Tugas Panggilan',
      CallPlans: 'Rencana Panggilan',
      CallStrategy: 'Strategi Panggilan',
      CallDetails: 'Detail Panggilan',
      transferOrNot: 'Ditransfer ke Agen atau Tidak',
      BlackList: 'Daftar Hitam (Blacklist).',
      CallAssistant: 'Asisten panggilan',
      addMessage: 'SMS Panggilan Terputus Baru',
      deleteMessage: 'Hapus SMS Panggilan Terputus',
      editMessage: 'Edit SMS Panggilan Terputus',
      messageStatus: 'Status Panggilan Terputus',
      viewHangUpMessage: 'Detail Panggilan Terputus',
      WorkflowDashboardPage: 'Dasbor Alur Kerja',
      uploadList: 'Jumlah Kontak yang Diunggah',
      singularName: 'Kontak yang Dideduplikasi ',
      numberDelisting: 'Kontak yang Dibatalkan',
      numberWorkflowTasks: 'Tugas Alur Kerja Dibuat',
      workflowTasksExecution: 'Tugas Alur Kerja yang Sedang Berlangsung',
      uploadListNumberTrend: 'Tren Kontak yang Diunggah',
      callsInList: 'Total Kontak yang Dihubungi',
      redialListNumber: 'Kontak Dideduplikasi yang Dihubungi',
      numberDeconnecting: 'Jumlah Kontak Terhubung yang Dideduplikasi',
      disconnectionRate: 'Tingkat Capaian yang Dideduplikasi',
      totalNumberCalls: 'Panggilan yang Dihubungi',
      totalNumberRounds: 'Panggilan Tersambung',
      totalConnectionRate: 'Total Tingkat Panggilan yang Tercapai',
      AverageConnectedCalls: 'Rata-rata Panggilan',
      averageNumberCalls: 'Rata-rata Percobaan untuk Panggilan',
      onAverageNumberCalls: 'Rata-rata Percobaan untuk Setiap Panggilan Tersambung',
      averageCallDuration: 'Rata-rata Durasi Panggilan ',
      averageInteractiveRounds: 'Rata-rata Jumlah Putaran Interaksi',
      averageRingingDuration: 'Rata-rata Durasi Berdering',
      tryTurnLaborNumber: 'Percobaan untuk mentransfer ke agen',
      attemptAgentNum: 'Percobaan untuk mentransfer ke agen',
      attemptTransferLaborRate: 'Tingkat Percobaan Transfer',
      numberSuccessfulTransfers: 'Jumlah Transfer yang Berhasil',
      successRateTransfer: 'Tingkat Keberhasilan Transfer',
      robotSearch: 'Pencarian Robot',
      platformSearch: 'Cari berdasarkan Platform',
      downloadData: 'Unduh',
      trendNumberCallsList: 'Tren jumlah Kontak yang Dihubungi',
      labelDistributionTrend: 'Tren Distribusi Niat',
      connectionRateTrend: 'Tren Tingkat Capaian',
      callDurationDistribution: 'Distribusi Durasi Panggilan',
      callDurationDistributionTrend: 'Tren Distribusi Durasi Panggilan',
      ringClassification: 'Tipe Dering',
      hangUpSort: 'Tipe Penutupan Panggilan',
      trendLaborTransferRate: 'Tren Tingkat Transfer',
      outboundCall: 'Outbound call',
      sms: 'sms',
      waMessage: 'WA Message',
      pds: 'PDS',
      waTemplate: 'WA Template',
      shortMessagesSent: 'Total Kontak yang Dikirimkan SMS',
      smsSingularName: 'Kontak yang Dikirimkan SMS Setelah Dideduplikasi',
      goTo7DayHits: 'Diklik dalam 7 hari setelah deduplikasi',
      goClickThroughRate: 'Tingkat Klik Setelah Dideduplikasi.',
      totalNumberTransmissions: 'Total Terkirim',
      total7DayHits: 'Total yang Diklik dalam 7 Hari',
      clickRate: 'Tingkat Klik',
      averageNumberTransmissions: 'Rata-rata Jumlah Pengiriman',
      trendNumberShortMessage: 'Tren Kontak yang Dikirimkan SMS',
      clickRateTrend: 'Tren Tingkat Klik',
      waSmsSingularName: 'WA Kontak yang Dikirimkan SMS Setelah Dideduplikasi',
      waGoTo7DayHits: 'WA Diklik dalam 7 hari setelah deduplikasi',
      waGoClickThroughRate: 'WA Tingkat Klik Setelah Dideduplikasi.',
      waTotalNumberTransmissions: 'WA Total Terkirim',
      waTotal7DayHits: 'WA Total yang Diklik dalam 7 Hari',
      waClickRate: 'WA Tingkat Klik',
      waAverageNumberTransmissions: 'WA Rata-rata Jumlah Pengiriman',
      waTrendNumberShortMessage: 'WA Tren Kontak yang Dikirimkan SMS',
      waClickRateTrend: 'WA Tren Tingkat Klik',
      waShortMessagesSent: 'WA Total Kontak yang Dikirimkan SMS',
      numberPdsList: 'Kontak PDS',
      pdsSingularName: 'Jumlah Kontak PDS yang Dideduplikasi',
      trendPdsListNumber: 'Tren Kontak PDS',
      waTemplateTotalNumber: 'Total jumlah Kontak yang dikirimkan Template WA',
      waTemplateSingularName: 'Jumlah Kontak Dideduplikasi yang Dikirimkan Template WA',
      wtTotalNumberTransmissions: 'WT Total Terkirim',
      wtAverageNumberTransmissions: 'WT Rata-rata Jumlah Pengiriman',
      waTemplateIndicates: 'Tren jumlah Template WA yang dikirim ke Kontak',
      sendNumberTrend: 'Tren Jumlah Pengiriman',
      deliveryNumber: 'Jumlah SMS Terkirim',
      successTransmissions: 'Jumlah SMS yang Berhasil Terkirim',
      successResending: 'Pengiriman unik yang berhasil',
      waDeliveryNumber: 'WA Pesan Berhasil Terkirim',
      waSuccessTransmissions: 'WA Pesan yang berhasil dikirim',
      waSuccessResending: 'WA Pengiriman unik yang berhasil',
      custom_components: 'Komponen Kustom',
      holiday: 'holiday',
      viewDashboard: 'Ikhtisar data',
      WorkflowVersion: 'WorkflowVersion',
      archive_rows: 'Lihat Daftar Versi',
      WorkflowComponents: 'Komponen Alur Kerja',
      time: 'time',
      manual: 'manual',
      slot: 'slot',
      user_latest_intention: 'user_latest_intention',
      customized_attributes: 'customized_attributes',
      splitter: 'splitter',
      url_click: 'url_click',
      combination: 'combination',
      voicebot_call: 'voicebot_call',
      voicebot_agent_call: 'voicebot_agent_call',
      pds_call: 'pds_call',
      wa_message: 'wa_message',
      api: 'api',
      voicebot_kit: 'voicebot_kit',
      mail: 'mail',
      PDSConfig: 'Konfigurasi PDS',
      voicemail: 'Kotak suara',
      qa: 'Tombol QA',
      contactNumberInterval: 'Interval Nomor Kontak',
      create: 'Tambahan',
      status: 'Status',
      Tools: 'Layanan dan Pengaturan',
      personalSetting: 'Pengaturan Pribadi',
      personalInfo: 'Informasi pribadi',
      avatar: 'Ubah avatar',
      email: 'Hubungkan Dengan E-mail Baru',
      loginInfo: 'Informasi Login',
      '2FA': '2FA',
      viewNumber: 'Lihat Teks Biasa',
      MingWenDownload: 'Unduh Teks Biasa',
      timeZone: 'Ubah Zona Waktu',
      contact: 'Tampilan Kontak Perusahaan',
      approvalBack: 'Setujui - Tarik Kembali',
      approvalPlanBack: 'Setujui - Tarik Kembali',
      ringSorts: 'Tipe Dering',
      updateListNumber: 'Kontak yang Diperbarui',
      accessControl: 'Kontrol Akses',
      BusinessInsight: 'Wawasan Bisnis',
      webhookPage: 'Konfigurasi Callback',
      callbackEvent: 'Event Callback ',
      encryptionPolicy: 'Event Callback ',
      intelligentOutbound: 'Panggilan Outbound Intelligent',
      intelligentInbound: 'Panggilan Inbound Intelligent',
      addCallbackEvent: 'Event Callback Baru',
      simuCallback: 'Simulasi Callback',
      Customer: 'Manajemen Pelanggan',
      downloadBlock: 'Unduhan Data Terblokir',
      delBlock: 'Hapus Data Terblokir',
      customSet: 'Pengaturan Kustom',
      validCallToal: 'Panggilan Tersambung yang Efektif',
      validRepeatToal: 'Koneksi Efektif setelah Duplikasi Dihapus',
      validCallRate: 'Tingkat Koneksi Efektif',
      validRepeatRate: 'Tingkat Koneksi Efektif setelah Duplikasi Dihapus',
      mainCallDayFB: 'Volume Panggilan Utama Harian',
      pdsReasonDayFB: 'Alasan Transfer Harian',
      robotLabelDayFB: 'Distribusi Niat Harian',
      newUserNum: 'Kontak Baru',
      oldUserNum: 'Kontak Lama',
      orderCreateDayFB: 'Jenis Tiket Harian',
      xjqsOrderDayFB: 'Tanda Terima Palsu Harian',
      validCallDes: 'Distribusi Panggilan Valid',
      hangTypeDes: 'Distribusi Jenis Penutupan Panggilan',
      avgCallTimeDes: 'Distribusi Rata-rata Durasi Panggilan',
      satisScoreDis: 'Peringkat Bot dan Tingkat Kepuasan',
      usersDayFB: 'Distribusi Harian Kontak',
      agentAvgDuration: 'Rata-rata Durasi Panggilan Agen',
      falseSign: 'Tanda Tangan Palsu',
      robotPerf: 'Kinerja Bot',
      userStats: 'Statistik Kontak',
      businessView: 'Wawasan Bisnis',
      transSuccessRate: 'Tingkat Keberhasilan Transfer ke Agen',
      robotEvalRate: 'Tingkat Evaluasi Bot',
      robotSatisAvgScore: 'Rata-rata Skor Kepuasan Bot',
      validCallNum: 'Volume Panggilan Efektif',
      callerNum: 'Contactos entrantes',
      validUser: 'Kontak Aktif',
      repeatCallRate: 'Tingkat Panggilan Berulang',
      robotOneTime: 'Tingkat Resolusi Kontak Pertama oleh Bot',
      robotOneTimeChart: 'Tingkat Resolusi Kontak Pertama oleh Bot Echart',
      maxCurTrend: 'Konkurensi Puncak Harian',
      dataExport: 'Ekspor Data',
      intentAccuracy: 'Tingkat Akurasi Niat',
      feedback: 'Feedback Pengecualian'
    },
    disabled: 'Telah dinonaktifkan',
    enabled: 'Telah diaktifkan',
    user_table: 'Daftar pengguna',
    role_table: 'Daftar nama karakter',
    Inbound: 'inbound.inbound',
    resMust: 'Silakan pilih setidaknya satu izin.'
  },
  dashboard: {
    noData: 'Tidak ada data',
    // overview: 'Data kunci',
    overviewDescription: 'Sementara data sedang dihitung,data harian akan keluar pada pukul 12 setiap harinya.',
    totalNumOfCalls: 'Jumlah Nomor Panggilannya',
    durationOfCall: 'Durasi (detik)',
    avDurationOfCalls: 'Durasi rata-rata (detik)',
    reachedNum: 'Jumlah Tersambung(buah)',
    totalCost: 'Total biaya',
    averageCost: 'Biaya rata-rata',
    reachedRateOfCall: 'Tingkat Tersambung',
    // intentions of customers
    customerIntention: 'Niat pelanggan',
    customerIntention_distinct: 'Niat pelanggan setelah direduplikasi',
    reachedRate_distinct: 'Tingkat Tersambung setelah direduplikasi',
    total_customer_distinct: 'Total pelanggan',
    total_reached_distinct: 'Total Tersambung',
    // duration of calls
    durationOfCalls: 'Total durasi panggilan',
    callLength: 'Durasi panggilan',
    number: 'Jumlah',
    comingSoon: 'Dalam tahap pengembangan',
    overallResult: 'Overall Result',
    // duration: 'Durasi(s)',
    // dashboard 底部table
    table: {
      taskName: 'Nama tugas',
      totalCost: 'Total biaya',
      total: 'Jumlah Nomor panggilan',
      unreached: 'Jumlah tidak Tersambung',
      reached: 'Jumlah Tersambung',
      successRate: 'Tingkat Capaian',
      totalDuration: 'Total waktu(detik)',
      average: 'Durasi rata-rata(detik)',
      intention: 'Label niat'
    },
    viewDataTip: 'Silahkan hubungi manajer pelanggan untuk melihat lebih banyak data',
    plans: 'Jumlah rencana',
    tasks: 'Jumlah tugas',
    calling_tasks: 'Tugas sedang dalam panggilan',
    pending_tasks: 'Tugas yang tertunda',
    total_callee: 'Jumlah nomor yang akan dipanggil',
    reached_rate: 'Tingkat Capaian',
    average_call_duration: 'Rata-rata durasi per panggilan',
    average_call_waiting_duration: 'Rata-rata waktu tunggu panggilan',
    today: 'Hari ini',
    last_three_day: '3 hari terakhir',
    last_seven_day: '7 hari terakhir',
    overview: 'Data Overview',
    call_analysis: 'Analisis panggilan',
    vdoing: 'Dimensi statistik',
    khyxzb: 'Niat pelanggan/Overall Result',
    xsjgfb: 'Distribusi hasil IC',
    callTime: 'Durasi panggilan',
    ringType: 'Kategori nada dering',
    nocallType: 'Kategori panggilan dimatikan',
    callTrend: 'Tren Tingkat Capaian',
    byHour: 'Menurut jam',
    byDay: 'Menurut hari',
    allTrend: 'Tren niat pelanggan',
    icResult: 'Tren hasil IC',
    duration: 'Waktu panggilan rata-rata',
    average_time: 'Waktu tunggu panggilan rata-rata',
    tasklist: 'Daftar tugas',
    total_types: 'Semua Kategori',
    all: 'Semua',
    all_task: 'Semua tugas',
    all_robot: 'Semua robot',
    all_results: 'Semua hasil',
    all_trends: 'Semua niat pelanggan',
    shuliang: 'Jumlah',
    shichang: 'Durasi(s)',
    unduplicated: 'Total',
    duplicate: 'Tidak ada deduplikasi',
    totalTrend: 'Total hasil',
    everyCallTime: 'Durasi panggilan harian',
    totalNumber: 'Jumlah total daftar',
    totalCallNumber: 'Jumlah total koneksi',
    totalCallRate: 'Total Tingkat Panggilan yang Tercapai',
    noConnectedNumber: 'Jumlah tidak terhubung',
    tocallNumber: 'Jumlah panggilan keluar',
    max_day_data: 'Dapat memilih data dalam rentang waktu maksimal 30 hari',
    by_task: 'Menurut tugas',
    by_robot: 'Menurut robot',
    plans_tooltip: 'Jumlah rencana yang waktu mulai rencana berada dalam rentang waktu filter',
    taks_tooltip: 'Jumlah tugas yang waktu mulai tugas berada dalam rentang waktu filter',
    calling_tasks_tooltip: 'Jumlah tugas yang sedang dipanggil dalam rentang waktu filter',
    pending_tasks_tooltip: 'Jumlah tugas panggilan yang akan dilakukan dalam rentang waktu filter;',
    total_callee_tooltip: 'Total jumlah panggilan dalam rentang waktu filter',
    reached_rate_tooltip: 'Total jumlah panggilan yang tersambung dalam rentang waktu filter',
    average_call_duration_tooltip: 'Total durasi panggilan terhubung dalam rentang waktu filter',
    average_call_waiting_duration_tooltip: 'Rata-rata durasi panggilan dari semua panggilan dalam rentang waktu yang filter',
    khyxzb_hover_explain: '(1)Statistik pembagian semua label berdasarkan filter yang ditentukan\n (2)Bedakan dengan nomor telepon',
    callTime_hover_explain: 'Distribusi data berdasarkan durasi panggilan dalam rentang waktu filter',
    ringType_hover_explain: 'Distribusi data dering panggilan dalam rentang waktu filter',
    nocallType_hover_explain: 'Distribusi data panggilan dimatikan dalam rentang waktu filter',
    call_tip_filter_rule: '(1)Persentase panggilan yang tersambung di dalam setiap hari dalam rentang waktu filter \n (2)Bedakan dengan nomor telepon',
    trend_tip: 'Distribusi data setiap niat pelanggan dalam rentang waktu filter',
    duration_tip: 'Distribusi data rata-rata durasi panggilan setiap hari dalam rentang waktu filter',
    average_time_tip: 'Distribusi data rata-rata durasi panggilan dari semua panggilan dalam rentang waktu yang filter',
    tasklist_tip: 'Statistik data panggilan dari setiap tugas dalam rentang waktu yang filter',
    connect_number_tooltip: 'Total Jumlah terhubung dalam rentang waktu filter',
    all_talk_time_tooltip: 'Total durasi panggilan terhubung dalam rentang waktu filter',
    connect_number: 'Jumlah total tersambung',
    all_talk_time: 'Durasi (detik)',
    dimension: 'Dimensi Deduplikasi'
  },
  workbenchtable: {
    // 首页表格
    total: 'Jumlah panggilan',
    unreached: 'Jumlah tidak Tersambung',
    reached: 'Jumlah Tersambung',
    successrate: 'Tingkat Tersambung',
    totalduration: 'Total waktu (detik)',
    average: 'Durasi rata-rata(detik)'
  },
  taskPlan: {
    tpDone: 'Disetujui',
    tpWati: 'Menunggu Persetujuan',
    tpReject: 'Ditolak',
    tpBack: 'Ditarik Kembali',
    tpCreated: 'Telah dibuat',
    wait: 'Informasi tugas telah diajukan. Harap tunggu persetujuan.',
    planWait: 'Informasi rencana telah diajukan. Harap tunggu persetujuan.',
    approveTime: 'Waktu Persetujuan',
    creator: 'Dibuat oleh',
    taskStatus: 'Status Tugas',
    planStatus: 'Status Rencana',
    approve: 'Menyetujui',
    back: 'Menarik Kembali',
    dlList: 'Unduh Daftar',
    pass: 'Menyetujui',
    noPass: 'Menolak',
    confirmBack: 'Apakah Anda yakin ingin menarik kembali?',
    approvalOK: 'Disetujui, Nama Tugas: {name}',
    approvalNO: 'Ditolak, Nama Tugas: {name}',
    planOK: 'Disetujui, Nama Rencana: {name}',
    planNO: 'Ditolak, Nama Rencana: {name}',
    taskBack: 'Tarik Kembali Tugas: {name}',
    planBack: 'Tarik Kembali Rencana: {name}',
    planTime: 'Tanggal Rencana',
    goApprove: 'Masuk ke Persetujuan'
  },
  execall: {
    // executecall.vue和executecallTable和exetestForm中数据
    taskCheck: 'Waktu pelaksanaan tugas panggilan harus lebih lama dari interval panggilan ulang * jumlah panggilan ulang',
    strategyCheck: 'Waktu kebijakan harus lebih lama dari interval panggil ulang * jumlah panggilan ulang',
    task: 'Task',
    DueDate: 'DueDate',
    genderselect: 'Seks',
    BorrowerName: 'Nama peminjam',
    BorrowedAmount: 'Jumlah pinjaman',
    BorrowedDate: 'Tanggal pinjaman',
    TotalOwingAmount: 'Total',
    platName: 'Nama platform',
    finished: 'Selesai',
    executecall: 'Melakukan panggilan',
    taskname: 'Nama tugas',
    testname: 'Nama tes',
    voicetemplate: 'Robot',
    calltime: 'Waktu panggilan',
    endtime: 'Waktu akhir',
    addtasks: 'Tambahkan tugas',
    addstrategy: 'Tambahkan strategi',
    editstrategy: 'Berubah strategi',
    testcall: 'Tes',
    successimport: 'Nomor yang berhasil diunggah',
    updatetime: 'Waktu memperbarui',
    createtime: 'Waktu pembuatan',
    starttime: 'Waktu mulai',
    callstate: 'Status',
    operation: 'Operasi',
    searchinfo: 'Mencari informasi',
    Filepath: 'Jalur file',
    DownLoad: 'Unduh',
    resume: 'Pemulihan',
    cancel: 'Batal',
    source: 'Sumber',
    details: 'Detail',
    pause: 'Berhenti',
    start: 'Mulai',
    progress: 'Kemajuan',
    submit: 'Submit',
    utcselect: 'Pemilihan zona waktu',
    templatselect: 'Pemilihan template',
    routeselect: 'Pemilihan rute ',
    upload: 'unggah data',
    expired: 'Kedaluwarsa',
    recall: 'Apakah dipanggil ulang',
    timeselect: 'Pemilihan waktu',
    starttimeselect: 'Waktu mulai',
    endtimeselect: 'Waktu akhir',
    downtemplate: 'Unduh template',
    yes: 'Ya',
    no: 'Tidak',
    interval: 'Interval redial (menit)',
    maxnumrecall: 'Nomor redial (tidak termasuk pertama kali)',
    platform: 'Platform',
    reset: 'Setel ulang',
    createdtimerange: 'Pilih waktu pembuatan',
    createdtimeto: 'Pilih waktu pembuatan',
    tianjia_task: 'Tambahkan tugas',
    addplan: 'Tambahkan rencana',
    planname: 'Nama rencana',
    calling_strategy: 'Strategi ',
    sip: 'Rute',
    actions: 'Operasi',
    date: 'Tanggal',
    strategy: 'Strategi',
    view: 'Lihat',
    calleeNumber: 'Nomor panggilan',
    calltimerange: 'Rentang waktu panggilan',
    save: 'Simpan',
    addTask: 'Tambahkan tugas',
    importNames: 'Unggah info kontak',
    checkNames: 'Verifikasi data',
    over: 'Selesai',
    input_names: 'Silakan unggah informasi kontak',
    download_fillin: 'Download template dan isi sesuai format',
    already_list: 'Unggah daftar yang sudah diisi',
    xiazai_template: 'Download template',
    upload_names: 'Unggah info kontak',
    select_drug: 'Pilih dan masukkan file ke area ini untuk diunggah',
    error_words: 'Apakah anda ingin membuat tugas berdasarkan data baru yang sudah dimasukkan?',
    ten_data: 'Hanya 10 item yang ditampilkan saat ini, untuk informasi lebih lanjut, silakan',
    total_error_data: 'Download semua data yang gagal',
    reject_number: 'Data yang diunggah tidak termasuk nomor dalam daftar hitam',
    fail_list: 'Daftar kegagalan',
    error_content: 'Konten Kesalahan',
    renwu_list: 'Daftar tugas',
    line: 'Baris',
    all_numbers: 'Jumlah total',
    success: 'Berhasil',
    fail: 'Gagal',
    add_plans: 'Tambahkan rencana panggilan',
    plan_name: 'Nama rencana',
    check_plan: 'Lihat rencana',
    set_plan: 'Tetapkan rencana',
    round: 'Putaran saat ini',
    reupload: 'Unggah ulang',
    import_result: 'Unggah hasil',
    add_success: 'Tugas berhasil ditambahkan',
    setDialTime: 'Harap tunggu, panggilan akan dilakukan pada waktu yang ditentukan',
    countdown: 'Tutup halaman secara otomatis setelah {number} detik',
    pre_step: 'Langkah sebelumnya',
    next_step: 'Langkah berikutnya',
    create_task: 'Buat tugas',
    project_list: 'Daftar rencana',
    gap_times: 'Jumlah panggilan ulang',
    gap: 'Interval panggilan ulang',
    viewRobotIntr: 'Lihat Info. Robot',
    robotIntr: 'Info. Robot',
    setOutboundCallPlan: 'Atur tugas panggilan keluar',
    selectStartTime: 'Silakan pilih waktu mulai terlebih dahulu.',
    distance: 'jarak waktu mulai',
    halfHour: '0.5 jam',
    oneHour: '1 jam',
    oneHalfHour: '1.5 jam',
    twoHours: '2 jam',
    timeHorizon: 'Silakan pilih waktu dalam kisaran 6:00-22:00',
    totalCount: 'Jumlah Total Kontak yang Ditelepon',
    uploadCount: 'Jumlah Kontak yang Diunggah',
    distinctReachRate: 'Tingkat Jangkauan Deduplikasi',
    allstrategy: 'Semua Strategi',
    allplan: 'Semua Paket',
    searchTip: 'Hanya data panggilan yang dibuat setelah tanggal 14 April 2023 yang dapat ditanyakan dengan metode ini.',
    day5Error: 'Waktu mulai dan waktu selesai tidak boleh lebih dari 5 hari dari tanggal saat ini.',
    fileSuccess: 'File berhasil diunggah'
  },
  accessControl: {
    ipBlack: 'IP Blacklist',
    ipWhite: 'IP Whitelist',
    currentIP: 'IP Blacklist saat ini hanya berlaku untuk klien yang mengakses melalui API.',
    currentIP2: 'IP Whitelist saat ini hanya berlaku untuk klien yang mengakses melalui API.',
    delIP: 'Hapus Alamat IP',
    addIP: 'Alamat IP Baru',
    ipAdd: 'Alamat IP',
    addBlack: 'Tambahkan ke Blacklist',
    addWhite: 'Tambahkan ke Whitelist',
    editBlack: 'Edit Blacklist',
    editWhite: 'Edit Whitelist',
    ipTip: `Mendukung semua alamat IP, seperti 10.0.0.10 atau FF05:B5; mendukung alamat format CIDR, seperti 10.0.0.0/16 atau FF05:B5/60; gunakan pemisah baris untuk memisahkan, dan Anda dapat menambahkan hingga 20 alamat sekaligus.`,
    required: 'Diperlukan',
    noCaseIP: 'Alamat IP Salah',
    more20: 'Masukkan hingga 20 alamat IP',
    confirmDeleteIP: 'Apakah Anda yakin ingin menghapus IP ini?'
  },
  webhook: {
    callback: 'Event Callback',
    encryption: 'Kebijakan Enkripsi',
    itOutbound: 'Panggilan Outbound Intelligent',
    itInbound: 'Panggilan Inbound Intelligent',
    addCallback: 'Event Callback Baru',
    editCallback: 'Edit Event Callback',
    eventType: 'Jenis Event',
    requestURL: 'Request URL',
    requestIP: 'Request IP',
    requestField: 'Request Parameter',
    muBack: 'Simulasi Callback',
    weSupport:
      'Untuk mode Webhook tradisional kami, kami mengharuskan Anda menyediakan alamat jaringan publik untuk menerima pesan event. Ketika event yang bersangkutan terjadi, kami akan mengirimkan request HTTP POST ke alamat jaringan publik server Anda, termasuk data event dalam request tersebut. Jika Anda memerlukan transmisi terenkripsi, silakan konfigurasikan "Kebijakan Enkripsi."',
    task_detail: 'Notifikasi Panggilan Selesai dalam Tugas',
    task_detail_ic: 'Notifikasi Panggilan Selesai dalam Tugas (Info-Checker)',
    task_end: 'Notifikasi Penyelesaian Tugas',
    plan_end: 'Notifikasi Penyelesaian Rencana',
    wf_detail: 'Notifikasi Panggilan Selesai dalam Alur Kerja',
    wf_detail_ic: 'Notifikasi Panggilan Selesai dalam Alur Kerja (Info-Checker)',
    wf_apinode: 'Notifikasi Penyelesaian Panggilan Alur Kerja dan Entri Node API',
    wf_detail_end: 'Notifikasi Penyelesaian Daftar Alur Kerja',
    wf_status: 'Notifikasi Perubahan Status Alur Kerja',
    ib_transfer: 'Notifikasi setelah Berhasil Mentransfer ke Agen',
    ib_detail: 'Notifikasi setelah Panggilan Berakhir',
    verify: 'Verifikasi',
    verified: 'Terverifikasi',
    verified_error: 'Verifikasi Gagal',
    stru: 'Struktur Data',
    show: 'Contoh',
    field: 'Kolom',
    orMust: 'Wajib atau Tidak',
    tips1: `1. API requests mendukung skema otentikasi tanda tangan terenkripsi AES+SHA256. Request parameters dan data respons dapat dienkripsi menggunakan algoritma AES selama transmisi untuk memastikan bahwa hanya penerima yang berwenang yang dapat mendekripsi dan mengakses data tersebut. Saat menandatangani request parameters dan data respons, algoritma SHA256 digunakan untuk menghasilkan ringkasan. Ringkasan ini dikirim bersama dengan request atau respons, dan penerima dapat memverifikasi integritas ringkasan untuk memastikan integritas data dan mencegah gangguan. Saat ini, Anda dapat mengonfigurasi kunci enkripsi Anda (ClientEncryptionKey) untuk requesting kami, serta kunci enkripsi kami (ServerEncryptionKey) untuk requesting Anda.`,
    tips2:
      '2. Beberapa data event callback berisi kolom tanda tangan untuk memverifikasi integritas dan keamanan data callback. Anda dapat mengonfigurasi CallbackSignKey untuk menghitung tanda tangan.',
    urlError: 'Verifikasi Alamat Request Gagal',
    requestEn: 'Request Key dan Callback Key',
    backKey: 'Callback Signature Key',
    confirmSave: 'Konfirmasi dan Simpan?',
    lii: 'Limit ClientEncryptionKey: 16, 24, atau 32 karakter',
    lii2: 'Limit ServerEncryptionKey: 16, 24, atau 32 karakter',
    lii32: 'Limit CallbackSignKey: 32 karakter',
    cTooltip: 'Ini adalah encryption key yang digunakan saat Anda request kami, dengan nilai default "airudderredduria".',
    sTooltip: 'Ini adalah encryption key yang kami gunakan saat requesting Anda untuk callback events.',
    bTooltip: 'Ini adalah parameter yang digunakan untuk menghitung kolom tanda tangan dalam beberapa event callback, dengan nilai default "airudder".',
    copySuccess: 'Disalin',
    viewField: 'Lihat Parameter',
    urlTip:
      'Setelah mengklik "Verifikasi," kami akan mengirim POST request yang diformat sebagai application/json;charset=utf-8 ke alamat request untuk memverifikasi keabsahan alamat yang dikonfigurasi. POST request ini berisi data simulasi untuk jenis event yang bersangkutan. Jika kode HTTP 200 diterima dalam rentang waktu percobaan ulang, verifikasi berhasil, jika tidak, verifikasi gagal.',
    fieldTip: 'Harap diperhatikan: Mengubah pengaturan ini juga akan memengaruhi return data dari API, termasuk API query.',
    requestUrlTip: 'Setelah alamat request diverifikasi, klik tombol "Konfirmasi". Kami akan mengirimkan HTTP POST request ke alamat jaringan publik server, dengan request yang berisi data simulasi.',
    noStableIP: 'Tanpa IP Statis',
    plwf: 'Konfigurasikan URL Panggilan Kembali di Templat Alur Kerja.',
    pass: 'Terverifikasi',
    noPass: 'Verifikasi Gagal'
  },
  progress: {
    // 查看进度dialog
    checkprogress: 'Lihat proses',
    total: 'Total pengajuan',
    called: 'Jumlah panggilan',
    unreached: 'Jumlah tidak Tersambung',
    reached: 'Jumlah yang Tersambung',
    ok: 'oke',
    overview: 'Lihat',
    title: 'Sedang mengunggah',
    tip: 'Sedang mengunggah daftar nama untuk anda, mungkin perlu beberapa menit, harap sabar menunggu'
  },
  tips: {
    // 二次确认提示框
    tips: 'Prompt',
    start: 'Pasti mulai?',
    cancel: 'Pasti batalkan?',
    pause: 'Pasti berhenti?',
    resume: 'Pastikan pulih?',
    close: 'Pastikan tutup?',
    close_strategy: 'Yakin ingin menutup halaman ini? Perhatikan bahwa operasi ini tidak akan disimpan setelah ditutup!',
    loading: 'Memuat',
    plsSelect: 'Silakan pilih',
    plsEnter: 'Silakan masukkan',
    regName: 'Silakan masukkan alfanumerik atau garis bawah',
    regPhone: 'Silakan masukkan nomor telepon yang benar.',
    regUrl: 'Silakan masukkan URL yang benar.',
    starttip: 'Telepon sekarang',
    back: 'kembali',
    confirmDel: 'Konfirmasi untuk penghapusan?',
    opsSuccess: 'Pengoperasian berhasil.',
    confirmCancel: 'Apakah Anda yakin ingin membatalkan ini?',
    repeat: 'Nama ini sudah ada'
  },
  testcall: {
    // testcall
    maxwarn: 'Jumlah panggilan tes saat ini telah mencapai maksimalnya',
    selecttimewarn: 'Silakan pilih waktu mulai dan waktu akhir sebelum memulai permintaan',
    search: 'Cari',
    type: 'Tipe Panggilan',
    interval: 'Pangilan Ulang Interval (Menit)',
    num: 'Waktu Panggilan Ulang (Tidak termasuk yang pertama kali)',
    testName: 'Nama Pengujian Panggilan Tunggal',
    test: 'Pengujian Panggilan Tunggal',
    inputAccount: 'Silahkan Masuk Akun',
    addTest: 'Menambahkan Panggilan Berdasarkan Strategi',
    addTask: 'Menambahkan Panggilan Berdasarkan Tugas',
    addCall: 'Tambahkan Panggilan',
    account: 'Akun',
    taskName: 'Nama Tugas',
    selectTask: 'Memilih Tugas untuk Menambahkan Panggilan',
    stime: 'Waktu Mulai (Dalam Panggilan-Menambahkan Zona Waktu)',
    etime: 'Waktu Selesai (Dalam Panggilan-Menambahkan Zona Waktu)',
    sta: 'Waktu Mulai (Zona Waktu Akun)',
    eta: 'Waktu Selesai (Zona Waktu Akun)',
    subTask: 'Subtugas',
    list: 'Jumlah Daftar',
    label: 'Label Intensi',
    robotName: 'Nama Robot',
    status: 'Menambahkan Status Panggilan',
    scs: 'Memilih Strategi Panggilan',
    callTime: 'Durasi Panggilan Tambahan',
    callNum: 'Menambahkan Putaran Panggilan',
    accountTime: 'Zona Waktu Akun',
    addType: 'Menambahkan Tipe Panggilan',
    adds: 'Menambahkan Strategi Panggilan',
    addSet: 'Menambahkan Pengaturan Panggilan',
    tip: 'Catatan : Zona Waktu Berdasarkan Layanan Akun',
    sd: 'Waktu Mulai',
    ed: 'Waktu Selesai',
    sat: 'Silahkan pilih Durasi Panggilan yang Ditambahkan',
    roundName: 'Nama Putaran',
    robot: 'Robot',
    st: 'Waktu Mulai',
    et: 'Waktu Selesai',
    opera: 'Pengoperasian',
    addc: 'Tambahkan Panggilan',
    cac: 'Batal Menambahkan',
    at: 'Waktu Mutlak',
    rt: 'Waktu Akhir Relatif',
    atb: 'Menambahkan Tugas dalam Jumlah Besar',
    atbTip: 'Diizinkan menambahkan Tugas dalam Jumlah Besar. Silahkan mulai garis baru untuk nama task yang berbeda',
    adddetail: 'Rincian Panggilan Tambahan',
    addID: 'Menambahkan ID Panggilan',
    cat: 'Menambahkan Tugas Panggilan',
    pa: 'Silahkan pilih akun untuk menambahkan panggilan',
    aea: 'Menambahkan/Menyunting Tugas Panggilan',
    aib: 'Menambakan dalam Jumlah Besar',
    pst: 'Silahkan pilih Waktu Mulai',
    pet: 'Silahkan pilih Waktu Selesai',
    reset: 'Setel Ulang',
    save: 'Simpan',
    ln: 'Jumlah Daftar',
    ct: 'Waktu Pembuatan',
    cstatus: 'Status Panggilan',
    remarks: 'Catatan',
    saname: 'Nama Tugas dari Akun yang Dipilih',
    rtst: 'Waktu Mulai Panggilan dari tugas terkait',
    rtet: 'Waktu Selesai Panggilan dari tugas terkait'
  },
  taskoverview: {
    taskoverview: 'Ikhtisar tugas',
    overview: 'Melihat'
  },
  formrulestips: {
    // RuleForm的提示语
    taskname: 'Silakan masukkan nama tugas',
    strategyname: 'Silakan masukkan nama strategi',
    planname: 'Silakan masukkan nama rencana',
    strategy: 'Silakan pilih strategi',
    repeat_interval: 'Silakan pilih jumlah interval',
    repeat_number: 'Silakan pilih jumlah pengulangan',
    intention: 'Silakan pilih niat',
    base: 'Silakan pilih basis',
    voicetemplate: 'Silakan pilih satu robot',
    lineselect: 'Silakan pilih jalur',
    starttime: 'Silakan pilih waktu mulai',
    date: 'Silakan pilih tanggal',
    endtime: 'Silakan masukkan waktu akhir',
    ifexpired: 'Silakan pilih waktu kedaluwarsa',
    ifrecall: 'Silakan pilih apakah akan dipanggil ulang',
    recallinterval: 'Silakan pilih interval panggilan ulang',
    maxnumrecall: 'Silakan pilih jumlah panggilan ulang maksimum',
    utc: 'Silakan pilih zona waktu',
    yes: 'Ya',
    no: 'Tidak',
    uploadsuccess: 'Unggah berhasil',
    excelempty: 'Excel kosong dan unggah gagal.',
    maxlimiation: 'Jumlah panggilan telah mencapai maksimalnya',
    reset: 'Setel ulang'
  },
  form: {
    upload: 'Unggah',
    uploadtip: 'Unggah data kontak',
    submit: 'Submit!',
    error: {
      uploadsize: 'Mohon jangan upload file lebih dari 1m.',
      uploadheader: 'Ada kesalahan tulisan dari title excel，mohon diisi sesuai dengan template.',
      uploadnum: 'Hanya bisa upload 1 file!',
      uploadformat: 'Hanya mendukung file formatnya xlsx，xls，csv，suffix.',
      date: 'There is an error in the excel date，Please fill in the data according to the template.'
    },
    download: 'Unduh Template',
    importfail: 'Data yang diunggah gagal.',
    allfail: 'Semua data yang diunggah gagal '
  },
  tableoperation: {
    pending: 'Pending',
    created: 'Telah dibuat',
    finished: 'Selesai',
    canceled: 'Telah dibatalkan',
    cancel: 'Batal',
    paused: 'Telah berhenti',
    reached: 'Tersambung',
    unreached: 'Tidak Tersambung',
    calling: 'Proses',
    planned: 'Rencanakan'
  },
  login: {
    login: 'login',
    logout: 'Logout',
    passwordLogin: 'Akun & Kata Sandi',
    ssoLogin: 'SSO ',
    slogan: 'Merepaskan produktivitas, yang didorong oleh AI',
    footer: 'Kerjasama bisnis: bianca.cheng@airudder.com | Hak cipta 2019 airudder.com',
    business_cooperation: 'Kerjasama bisnis: sales@airudder.com',
    all_right_reserved: 'Hak cipta {name} airudder.com',
    input_userName: 'Silakan masukkan akun',
    input_password: 'Silakan masukkan kata sandi',
    login_forget: 'Lupa Kata Sandi',
    concurrency_limit: 'Akun anda terdeteksi login di perangkat lain. Untuk memastikan keamanan akun, silakan masuk kembali dan segera ubah kata sandi Anda jika itu bukan Anda sendiri.',
    errorMessage: 'Sesi Anda telah berakhir. Silakan login kembali.',
    noRegister: 'Akun tidak terdaftar. Silakan hubungi kami untuk mendaftar lalu coba kembali.',
    noCanSSO: 'Akun ini tidak mendukung login SSO. Silakan hubungi kami untuk mendapatkan bantuan.'
  },
  calldetails: {
    translationLanguage: 'Pilih bahasa terjemahan',
    prevRecord: 'Rekaman sebelumnya',
    nextRecord: 'Rekaman berikutnya',
    callId: 'ID panggilan',
    dialogueRounds: 'Putaran panggilan',
    callDetails: 'Detail panggilan',
    translation: 'Terjemahkan',
    downloadRecord: 'Unduh rekaman',
    calldetails: 'Rincian',
    contact: 'Kontak',
    callid: 'ID',
    callduration: 'Durasi',
    intentionlabel: 'Label niat',
    callresult: 'Hasil',
    download: 'Unduh',
    reached: 'Tersambung',
    unreached: 'Tidak Tersambung',
    undialed: 'Tidak dipanggil',
    choosecreate: 'Pilih waktu pembuatan',
    choosecall: 'Pilih waktu panggilan',
    callnumber: 'Nomor telepon',
    timefrom: 'Waktu panggilan (dari)',
    timeto: 'Waktu panggilan (ke)',
    calltimerange: 'Waktu panggilan',
    inputnumber: 'Silakan masukkan nomor telepon',
    ringtype: 'Ring Type',
    hangtype: 'Hang-Up Type',
    comments: 'Komentar',
    questions: 'Questions',
    icresult: 'Result',
    A: 'A: success',
    B: 'B: failed',
    C: 'C: unfinished',
    D: 'D: others',
    E: 'E: no-answer',
    F: 'F: not connected',
    G: 'G: voicemail',
    Yes: 'Y: Yes,Callee confirm',
    No: 'N: No,Callee deny',
    Others: 'O: Others,No reply or meaningless reply',
    Skip: "S: Skip,Robot didn't ask",
    Non: "-: This question didn't exist",
    resultTipTitle: 'related to robot design',
    questionsTipTitle: 'reply to each question unit',
    tableTitle: 'Daftar rinci',
    prompt_robot_name: 'Silahkan pilih robot',
    prompt_intention: 'Silahkan pilih label niat',
    call_time: 'Waktu panggilan',
    create_time: 'Waktu dibuat',
    robot: 'Robot',
    prompt_overall_result: 'Silakan pilih hasil tinjauan informasi',
    userHangup: 'Dihentikan oleh Pengguna',
    RobotHangup: 'Digantung oleh AI',
    agentHange: 'Ditutup oleh Agen',
    cancelled: 'Dibatalkan',
    all_intention: 'Semua niat pelanggan',
    all_result: 'Semua hasil',
    lettersMeaning: 'Arti dari surat ditampilkan di sisi kanan bawah dari setiap daftar pertanyaan:',
    lettersMeaningLeft: 'Arti dari surat ditampilkan di sisi kiri bawah dari setiap daftar pertanyaan:',
    letterA: 'A：Jawaban dari penelepon (' - ' ketika hasil tidak tersedia)',
    letterV: 'V: Info verifikasi yang Anda unggah (' - ' ketika hasil tidak tersedia)',
    letterR: "R: Hasil verifikasi A dan V ('Match' ketika hasil sesuai; 'Not match' ketika hasil tidak sesuai; '-' ketika hasil tidak tersedia)",
    mainFlow: 'Proses Utama',
    robotPhoneLabel: 'Tujuan',
    isArtificial: 'Ditransfer ke Agen atau Tidak',
    userPhone: 'Nomor kontak',
    callingId: 'ID Panggilan',
    callingTime: 'Total Durasi Panggilan',
    scenario: 'Skenario Bisnis',
    pdfFailReason: 'Penyebab Kegagalan Transfer ke Agen',
    robotCallTime: 'Durasi Panggilan Robot',
    callDuration: 'Durasi Panggilan Agen',
    dialogueRound: 'Putaran Percakapan Bot',
    callTag: 'Hasil Agen',
    moreFilter: 'Filter Lainnya',
    visibleFields: 'Bidang untuk Ditampilkan dan Diunduh',
    hotPhone: 'Nomor Hotline',
    transfer: 'Tidak Ditransfer',
    transferSuccess: 'Berhasil Ditransfer',
    transferFail: 'Gagal Melakukan Transfer',
    cantConfirm: 'Mencoba tetapi tidak yakin',
    view: 'Melihat',
    hitMainProcess: 'Tekan Proses Utama',
    callTaskBeginTime: 'Waktu Mulai Tugas',
    beginCallTime: 'Waktu Mulai Panggilan',
    workflowName: 'Nama Alur Kerja',
    advancedSettings: 'Pengaturan Lanjutan',
    canSeeFields: 'Manajemen Visibilitas Bidang Dasar',
    nerSlots: 'Pengaturan Slot NER',
    eventLabels: 'Pengaturan Event Labels',
    listVariable: 'Pengaturan Daftar Variabel',
    showTip: 'Centang untuk mengontrol tampilan kolom, memfilter, atau mengunduh kolom',
    call_task_name: 'Tugas Panggilan',
    call_robot: 'Robot',
    wf_task: 'Tugas Alur Kerja',
    wf_template: 'Template Alur Kerja',
    call_plan: 'Rencana Panggilan',
    call_strategy: 'Strategi Panggilan',
    call_id: 'ID panggilan',
    phone_number: 'Nomor Telepon',
    call_intention: 'Label Niat',
    ringing_type: 'Tipe Dering',
    hangup_type: 'Tipe Penutupan Panggilan',
    transfer_status: 'Ditransfer ke Agen atau Tidak',
    platform_name: 'Platform',
    task_call_start_time: 'Waktu Mulai Tugas',
    real_call_start_time: 'Waktu Mulai Panggilan',
    ner_slots: 'NER slots',
    event_labels: 'Event labels',
    talk_duration: 'Durasi panggilan',
    talk_round: 'Putaran panggilan',
    task_id: 'ID Tugas',
    contact_name: 'Nama kontak',
    answer_time: 'Waktu Terhubung',
    real_call_end_time: 'Waktu Panggilan Berakhir',
    call_times: 'Jumlah Panggilan',
    call_comments: 'Comments',
    asr_result: 'ASR Result',
    phone_call_log: 'Catatan Panggilan Ulang',
    fieldShow: 'Kolom dan Urutan Tampilan',
    listField: 'Daftar Kolom',
    selectField: 'Aktifkan Item Filter',
    slotsTitle: 'Deskripsi Slot dan Unduh Pengaturan Header ',
    slotTip1: 'Catatan: Slot NER dikonfigurasi dalam alur robot. Semua slot robot ditampilkan di sini.',
    slotTip2:
      '1. Silakan atur apakah akan menampilkan slot saat terkena atau tidak sesuai kebutuhan Anda. Jika Anda centang "Tampilkan", slot yang terkena dan nilai slot akan ditampilkan dalam detail panggilan; jika Anda centang "Slot NER" terlihat dalam daftar di "Manajemen Visibilitas Bidang Dasar", slot yang terkena dan nilai slot akan ditampilkan dalam daftar panggilan;',
    slotTip3:
      '2. Silakan atur teks deskripsi sesuai kebutuhan Anda. Jika Anda telah mengatur teks deskripsi, teks deskripsi yang sesuai dan nilai slot akan ditampilkan ketika panggilan terkena slot; jika tidak, nama slot dan nilai slot akan ditampilkan;',
    slotTip4: '3. Please set whether a certain slot can be used as a filter item according to your needs;',
    slotTip5:
      '4. Please set whether a certain slot can be used as the Excel table header of the download list after it is hit according to your needs, and other slots and slot values that are not set will be uniformly put under the NER slots table header field.',
    slotDes: 'Deskripsi',
    canSee: 'Tampilkan atau Tidak',
    canDl: 'Apakah Akan Diunduh sebagai Header Tabel',
    eventTitle: 'Label Event Unduh Pengaturan Header Tabel ',
    eventTip: `Deskripsi:Event labels dikonfigurasikan dalam aliran bot. Event labels dari semua robot ditampilkan di sini. Harap konfigurasikan apakah akan mengunduh Event labels tertentu sebagai tajuk tabel Excel setelah dipukul sesuai dengan kebutuhan Anda. Label Acara lainnya akan ditampilkan di bawah tajuk yang sama - Event labels, dan pilih “Event labels” di “Manajemen Visibilitas Bidang Dasar”.`,
    tableDl: 'Apakah Akan Diunduh sebagai Header Tabel',
    listSet: 'Daftar Tampilan Variabel dan Unduh Pengaturan Header  ',
    variableTip:
      'Deskripsi: Di sini kami menampilkan semua daftar variabel yang diunggah dari 6 bulan terakhir hingga hari T-1. Silahkan tentukan apakah daftar variabel dapat dilihat dalam detail panggilan atau diunduh secara terpisah sebagai header Excel.',
    listTitle: 'Daftar Tampilan Variabel dan Unduh Pengaturan Header  ',
    listTip:
      'Catatan: Semua variabel daftar yang diunggah dalam 6 bulan terakhir hingga hari T-1 ditampilkan di sini. Silakan atur apakah variabel daftar dapat digunakan sebagai item filter, ditampilkan dalam daftar dan detail panggilan, atau digunakan sebagai header tabel Excel untuk daftar unduhan, sesuai kebutuhan.',
    listVar: 'Daftar Variabel ',
    callInfoTitle: 'Informasi Tugas Panggilan',
    callInformation: 'Informasi Panggilan',
    listInfo: 'Daftar Informasi ',
    listSource: 'Daftar Sumber ',
    asr_ptp: 'PTP',
    detail_status: 'Status Daftar',
    ringing_duration: 'Waktu Berdering',
    openFilter: 'Aktifkan Filter',
    exception_feedback: 'Feedback Pengecualian',
    exCategory: 'Jenis Pengecualian',
    exDialogue: 'Dialog Pengecualian',
    submitFeedback: 'Kirim Feedback',
    feedbackDetail: 'Detail Feedback',
    bigLabelErr: 'Intention Error',
    asrErr: 'ASR Error',
    flowErr: 'Alur Error',
    scriptErr: 'Skrip Error',
    plsExType: 'Silakan pilih jenis pengecualian.',
    plsSelectExMsg: 'Silakan periksa dialog dengan pengecualian di sebelah kiri.'
  },
  singeltest: {
    singeltest: 'Tes tunggal',
    template: 'Silakan pilih robot',
    sipselect: 'Silakan pilih rute',
    calling: 'Memanggil',
    called: 'Panggil ke',
    tele: 'Silakan masukkan nomor telepon',
    canused: 'Sisa tes panggilan',
    submit: 'Submit',
    reset: 'Setel ulang',
    numonly: 'Nomor Telepon hanya bisa diinput dengan angka',
    sip: 'Rute'
  },
  error: {
    404: 'Harap periksa kembali URL . Klik tombol di bawah ini untuk kembali ke beranda.',
    back: 'Kembali',
    planadd: 'Waktu plan yang anda gunakan sudah melebihi jadwal strategi, mohon dicoba lagi setelah lakukan penyesuaian'
  },
  strategy: {
    newround: 'Tambahkan putaran baru',
    list: 'Daftar Strategi',
    new: 'Tambahkan strategi',
    published: 'Diterbitkan',
    unpublished: 'Tidak diterbitkan',
    view: 'Melihat',
    edit: 'Edit',
    copy: 'Salinan',
    delete: 'Menghapus',
    strategy: 'Strategi',
    roundname: 'Nama putaran',
    roundnumber: 'Nomor putaran',
    strategyname: 'Nama strategi',
    entername: 'Masukkan nama strategi',
    maxrecall: 'Maksimum jumlah panggilan ulang',
    selecttag: 'Philih tag',
    selectrange: 'Rentang',
    tip: 'Tips: Interval antara dua putaran harus lebih dari 15 menit!',
    stratrgy_table: 'Daftar strategi',
    prompt_strategy_name: 'Silakan masukkan nama strategi',
    interval_time: 'tugas {round} harus berjarak setidaknya 15 menit dengan round(panggilan) sebelumnya',
    view_strategy: 'Melihat Strategi ',
    amxTag: 'Anda hanya dapat mengaplikasikan 12 filter, mohon ulangi pengaturan Anda',
    no_robot: 'Robot tidak ada, tolong coba lagi.'
  },
  robotExplain: {
    name: 'Nama robot',
    language: 'Ucapan',
    voice: 'Nada robot',
    range: 'Lingkup aplikasi ',
    paytime: 'waktu pemgembalian',
    recorder_gender: 'Jenis kelamin suara',
    voice_language: 'Bahasa',
    formal: 'Resmi',
    casual: 'Singkat',
    polite: 'Sopan',
    natural: 'Normal',
    tough: 'Keras',
    tougher: 'Beri tekanan',
    t4: 'T-4 serta yg diatasnya,IVR',
    t3: 'T-3 s/d T0',
    t0: 'pada tanggalnya',
    tadd1: 'T+1 ~',
    beforedue: '~ T-1',
    today: 'Hari ini'
  },
  excel: {
    appexist: 'Harap konfirmasi jika nama platform sudah benar.',
    dateformat: 'Format tanggal tidak valid. Silahkan ikuti contoh template.',
    dateinterval: '"Borrowed_date" harus lebih awal dari "due_date"'
  },
  blacklist: {
    add: 'Tambahkan daftar hitam',
    tip1: 'Mendukung unggah masal',
    tip2: 'Perlu jeda baris di antara nomor',
    invalidTip: 'format nomor telepon tidak valid',
    successTip: 'berhasil ditambahkan',
    deleteTip: 'konfirmasi untuk menghapus',
    deleteSuccess: 'Berhasil dihapus',
    simpleTip: 'Contoh daftar hitam',
    limit_service: 'Batasi panggilan',
    system_names: 'Daftar hitam sistem',
    manual_names: 'Daftar hitam manual',
    bl_type: 'Jenis daftar hitam',
    bl_list: 'Daftar hitam'
  },
  assistant: {
    title: 'Pemblokiran AI',
    add: 'Tambahkan kebijakan pemblokiran AI',
    type: 'Tipe',
    days: 'Hari Pertimbangan Kebijakan',
    result: 'Hasil panggilan',
    times: 'Waktu kumulatif',
    callTimes: 'Jumlah panggilan kumulatif',
    shieldDays: 'Hari blokir',
    shieldType: 'Metode blokir',
    lastTime: 'Orang yang terakhir kali memperbarui',
    tel: 'Nomor yang diblokir',
    shieldTime: 'Waktu blokir',
    task: 'Semua tugas',
    shieldData: 'Lihat data yang diblokir',
    pblj: 'Logika pemblokiran: Saat membuat tugas atau panggilan, tentukan apakah panggilan yang dilakukan dalam N hari terakhir memenuhi kondisi pemblokiran. Jika demikian, blokir selama M hari sesuai dengan metode pemblokiran yang dipilih. Jika tidak, jangan diblokir.',
    addznpbcl: 'Tambahkan kebijakan pemblokiran AI',
    clsm: 'Deskripsi Kebijakan',
    leftDay: 'N hari terakhir (hari keputusan kebijakan)',
    rightDay: 'M hari di masa mendatang (hari blokir)',
    shaft: 'Timeline ',
    createCalling: 'Waktu pembuatan tugas/panggilan',
    timePoint: 'Titik waktu X',
    radioOne: 'Blokir berdasarkan total keseluruhan hasil panggilan',
    radioTwo: 'Blokir berdasarkan total keseluruhan jumlah panggilan',
    inputOne: 'Tipe blokir ',
    inputTwo: 'Hari keputusan kebijakan ',
    inputThree: 'Kondisi Pemicu Pemblokiran',
    checkboxOne: 'Blokir saat membuat tugas',
    checkboxTwo: 'Blokir saat menelepon',
    spanOne: 'Total Waktu Panggilan',
    spanTwo: 'Hasil panggilan',
    spanThree: 'Waktu kumulatif',
    tooltip1:
      'Jenis pemblokiran ini akan memblokir nomor yang telah diberi label sebagai label terpilih sebanyak xx kali dalam hari pengecekan terakhir. Jika ada beberapa label yang dipilih, maka total waktu akan menjadi jumlah total waktu semua label.',
    tooltip2: 'Jenis ini akan diblokir berdasarkan jumlah hari yang Anda isi dengan penilaian bahwa telepon yang sama dipanggil sebanyak xx kali.',
    tooltip3: 'Jumlah hari (termasuk hari ini) yang perlu dipantau oleh kebijakan sebelum nomor tersebut diblokir',
    tooltip4:
      'Strategi dimana terdapat hari yang sudah ditentukan dari keputusan untuk memblokir nomor tersebut (termasuk hari ketika pemblokiran dimulai); jika nomor mulai hari ini diblokir selama 2 hari, maka nomor hanya akan diblokir untuk hari ini dan besok, dan akan ditunda pemblokirannya setelah 23:59:59 besok.',
    tooltip5: 'Saat membuat tugas, nomor telepon yang dituju akan diblokir dan tidak dapat diunggah',
    tooltip6: 'Saat menelepon, nomor telepon yang dituju akan diblokir dan tidak dapat dihubungi',
    placeholder: 'Silakan masukkan 1 hingga 180',
    tian: 'Hari',
    ci: 'Waktu',
    shieldTimes: 'Jumlah pemblokiran oleh sistem cerdas',
    smartNumber: 'Pemblokiran AI',
    rule6: 'Masukkan bilangan bulat positif dari 1-180',
    rule7: 'Masukkan bilangan bulat positif',
    rule1: 'Silakan pilih jenis pemblokiran',
    rule2: 'Silakan masukkan jumlah hari keputusan kebijakan',
    rule3: 'Silakan masukkan persyaratan pemblokiran.',
    rule4: 'Silakan masukkan jumlah hari pemblokiran',
    rule5: 'Silakan pilih metode pemblokiran',
    blockStrategy: 'Strategi Pemblokiran',
    blockTrigger: 'Strategi Pemblokiran Berdasarkan Pemicu',
    blockStartTime: 'Waktu Mulai Pemblokiran',
    blockEndTime: 'Waktu Akhir Pemblokiran'
  },
  personalInfo: {
    current_password: 'Kata sandi saat ini',
    input_current_password: 'Silakan masukkan kata sandi saat ini',
    input_new_password: 'Silakan masukkan kata sandi baru',
    error_current_password: 'Kata sandi salah',
    title: 'Informasi pribadi',
    group: 'Grup',
    role: 'Nama Karakter',
    account: 'Akun',
    icon: 'Avatar',
    resetIcon: 'Ubah avatar',
    accountInfo: 'Informasi akun',
    basicInfo: 'Informasi dasar',
    new_password: 'Kata sandi baru',
    error_confirm_password: 'Kedua kata sandi tidak sesuai'
  },
  message: {
    lessCurrentTime: 'Waktu mulai tidak boleh kurang dari waktu saat ini',
    lessFiveMin: 'Interval antara waktu berakhir dan waktu mulai tidak boleh dibawah 5 menit',
    errorStrategyTime: 'Strategi waktu panggilan yang dipilih tidak dapat dibuat lebih awal dari waktu saat ini',
    fail: 'Semua daftar gagal diunggah',
    upload: 'Mohon unggah list daftar!'
  },
  robot: {
    detail: 'Lihat Rincian',
    valid: 'Valid',
    invalid: 'Invalid',
    state: 'Status',
    action: 'Operasi',
    robot_name: 'Nama Robot',
    create_time: 'Waktu Dibuat',
    update_time: 'Waktu Update',
    audition: 'Putar audio',
    now_words: 'Skrip saat ini',
    words_list: 'Daftar Skrip',
    history: 'Riwayat Operasi',
    create_words: 'Buat Skrip baru',
    update_words: 'Edit Skrip',
    words_update: 'Edit Skrip',
    words_preview: 'Preview Script',
    words: 'Script',
    apply: 'Terapkan',
    update: 'Edit',
    delete: 'Hapus',
    fill_words: 'Isi Variabel Audio',
    start_audition: 'Mulai Memutar Audio',
    confirm_delete: 'Apakah Anda akan menghapus Script',
    confirm_apply: 'Apakah Anda akan menggunakan Script',
    sensitive_word: 'Adalah kata yang sensitif. Silakan ganti dan coba lagi.',
    suggest_cut: 'Lebih dari 90 detik , disarankan dikurangi.',
    add_words: 'Tambahkan Skrip baru',
    apply_words: 'Terapkan Skrip',
    delete_words: 'Hapus Skrip',
    explain: 'Catatan: Silakan salin parameter yang ingin Anda gunakan ke teks box untuk pengeditan Skrip',
    all_params: 'Semua Parameter',
    params_explain: 'Deskripsi Parameter',
    submit: 'Kirim',
    serial_number: 'Urutan',
    operation_type: 'Jenis Operasi',
    operation_time: 'Waktu operasi',
    operator: 'Operator',
    can_not_empty: 'Skrip tidak boleh kosong',
    integrity: 'Silakan lengkapi variabel audio',
    greetings: 'Salam pembuka, ditentukan secara otomatis berdasarkan waktu panggilan',
    borrower_name: 'Nama pengguna, Dalam layanan pemasaran, parameter ini sesuai dengan customer_name di template',
    gender: 'Jenis kelamin pengguna',
    borrow_money: 'Jumlah pinjaman，sesuai dengan borrowed_amount dalam template',
    borrow_total_money: 'Jumlah total pinjaman, sesuai dengan total_owing_amount dalam template',
    borrow_date: 'Tanggal pinjaman, sesuai dengan borrowed_date di template',
    due_date: 'Tanggal Jatuh Tempo Pinjaman',
    due_days: 'Total hari jatuh tempo: secara otomatis dikonversi sesuai dengan due_date dan tidak perlu diunggah',
    due_month: 'Bulan Jatuh Tempo: secara otomatis dikonversi sesuai dengan due_date\n dan tidak perlu diunggah',
    platform: 'Nama platform, sesuai dengan platform_name di template',
    borrow_month: 'Bulan pinjaman: otomatis dikonversi sesuai borrow_date dan tidak perlu diunggah',
    extra_a: 'Perluas Parameter',
    extra_b: 'Perluas Parameter',
    extra_c: 'Perluas Parameter',
    extra_d: 'Perluas Parameter',
    enter: 'Diisi',
    active: 'Valid',
    ineffective: 'Invalid',
    edit_remark: 'Edit Catatan Tambahan',
    remark: 'Catatan Tambahan',
    remark_max_length: 'Catatan Tambahan max. 40 huruf',
    robotId: 'ID Robot',
    idDesc: 'ID ini digunakan untuk memilih robot yang sesuai selama koneksi API.',
    tone: 'Nada',
    robotGender: 'Jenis kelamin',
    auditionRecord: 'Mencoba mendengar audio',
    politeness: 'Sopan',
    nature: 'Alami',
    tough: 'Keras',
    pressure: 'Tekanan',
    cruel: 'Garang',
    detailTab1: 'Label Deskripsi',
    detailTab2: 'Variabel robot',
    detailTable1: 'Label',
    detailTable2: 'Deskripsi',
    detailTable3: 'Variabel',
    detailTable4: 'Aturan',
    detailTable5: 'Contoh',
    labelGroup: 'Pengelompokkan Event labels',
    groupTip:
      'Catatan: Label peristiwa yang berasal dari robot yang sama dapat disatukan menjadi sebuah kelompok. Setelah diubah, nama pengelompokan baru akan muncul, label peristiwa yang tidak dikelompokan hanya dapat melihat label peristiwa sesuai aslinya. ',
    groupbtn1: 'Kelompok',
    groupbtn2: 'Batalkan pengelompokan',
    groupbtn3: 'Nama kelompok',
    errTip: 'Silakan memilih multi_intention',
    groupTableTitle: 'Kelompok label peristiwa',
    dashboardTip1: 'Label Prioritas ditetapkan sebagai {name}. Perbedaan akan didasarkan pada prioritas ini.',
    dashboardTip2:
      'All the numbers merujuk ke semua daftar, dan prioritas labelnya adalah {name} , Jika nomor telepon yang sama memiliki beberapa label yang berbeda di round sebelumnya, sistem akan menyusun berdasarkan label yang memiliki prioritas lebih tinggi terlebih dahulu.',
    dashboardTip3: 'Variabel yang ditampilkan di sini adalah semua variabel template di sisi web. Untuk variabel API, lihat dokumentasi API.'
  },
  safetyLogin: {
    change_email: 'Hubungkan Dengan E-mail Baru',
    desc_new_email: 'Silakan masukkan email baru untuk verifikasi',
    binding_email: 'Hubungkan Dengan E-mail ',
    desc_email: 'Silakan masukkan email Anda untuk verifikasi',
    to_bind: 'Hubungkan',
    prompt_email: 'Silahkan masuk email anda',
    invalid_email: 'Email tidak valid',
    enter_code: 'Silahkan masukkan kode verifikasi',
    fetch_code: 'Mendapatkan Kode Verifikasi',
    area_code: 'Kode Area No.Telepon',
    prompt_mobile: 'Silakan masukkan nomor telepon',
    bind_mobile: 'Hubungkan dengan nomor telephone',
    invalid_mobile: 'Nomor telepon tidak valid',
    error_code: 'Kode verifikasi salah, silakan coba lagi',
    prompt_area_code: 'Silakan pilih Kode Nomor Telepon Luar Negeri',
    again: 'Dapatkan kembali setelah {number} detik',
    safety_verification: 'Verifikasi Keamanan',
    verify_desc: 'Untuk memastikan bahwa ini anda sendiri, silahkan lakukan verifikasi melalui e-mail'
  },
  crossLogin: {
    name: 'Lintas Login',
    list: 'Daftar Akun',
    companyName: 'Nama Perusahaan',
    placeholder: 'Silakan masukkan akun login atau nama perusahaan Anda',
    tip: 'Saat ini masuk melalui lintas login, perilaku ini tidak boleh',
    checkout: 'Keluar Login'
  },
  LoginInfo: {
    login_set: 'Pengaturan Masuk',
    enabled: 'Aktif',
    not_enabled: 'Tidak Diaktifkan',
    declare:
      'Catatan: Demi keamanan akun Anda, disarankan agar Anda mengaktifkan 2FA; setelah menyalakannya, Anda perlu menghubungkan email Anda untuk menerima kode verifikasi dinamis selama verifikasi keamanan',
    login_log: 'Catatan Login',
    desc: 'Berikut ini adalah catatan login Anda selama sebulan terakhir. Jika ada catatan login yang tidak normal, harap ubah kata sandi Anda sesegera mungkin',
    open_FA: 'Aktifkan 2FA',
    serial: 'Nomor Seri',
    equipment: 'Sistem Peralatan',
    browser: 'Browser',
    area: 'Daerah',
    login_time: 'Waktu Login'
  },
  template: {
    callTime: 'Waktu Panggilan',
    experience_robot: 'Trial Robot',
    select_industry: 'Pilih industri',
    desc_first: 'Pilih jenis Robot sesuai kebutuhan Anda untuk trial',
    desc_second: 'Konten yang Anda masukkan akan disinkronisasi dengan naskah Robot',
    ps_industry_scenario: 'Pilih jenis industri - Skenario',
    ps_kansalliskieli: 'Pilih Negara - Bahasa',
    industry: 'Industri',
    ps_industry: 'Harap pilih jenis industri',
    scenario: 'Skenario',
    ps_scenario: 'Harap pilih jenis skenario',
    dial_country: 'Negara tujuan penelponan',
    ps_dial_country: 'Harap pilih Negara tujuan penelponan',
    robot_language: 'Bahasa yang digunakan Robot',
    ps_robot_language: 'Harap pilih bahasa yang digunakan Robot',
    time_zone: 'Zona Waktu',
    select_time: 'Harap pilih waktu penelponan',
    dial: 'Nomor tujuan penelponan',
    pe_dial: 'Harap masukkan nomor tujuan penelponan',
    country_code: 'Kode Telepon Negara',
    pe_borrower_name: 'Harap masukkan nama peminjam',
    pe_borrowing_balance: 'Harap masukkan jumlah pinjaman',
    total_amount_borrowed: 'Jumlah total pinjaman',
    pe_total_amount_borrowed: 'Harap masukkan total jumlah pinjaman',
    ps_Later_current_time: 'Harap pilih waktu diatas waktu saat ini',
    length_limit: 'Panjang antara 8-20 huruf',
    ps_start_time: 'Harap pilih waktu mulai',
    ps_borrowing_date: 'Harap pilih tanggal peminjaman',
    ps_due_date: 'Harap pilih tanggal jatuh tempo',
    country: 'Negara',
    language: 'Bahasa',
    recording_audition: 'Demo audio',
    experience_immediately: 'Trial sekarang',
    selectIndustry: 'Pilih industri dan skenario',
    industryList: 'Direktori Industri',
    robot: 'Robot',
    timbre: 'Warna nada/Jenis kelamin suara',
    tone: 'Intonasi',
    rangeApplication: 'Lingkup penggunaan',
    allIndustry: 'Semua industri'
  },
  tools: {
    manual: 'Panduan Penggunaan',
    document: 'Dokumen API',
    product: 'Layanan',
    tip1: 'Harap pilih layanan yang Anda inginkan',
    tip2: 'Silahkan pilih Bahasa yang digunakan',
    download_doc: 'Unduh dokumen',
    all: 'Tandai semua telah dibaca',
    infoList: 'Daftar pesan',
    more: 'Lihat selengkapnya',
    viewNow: 'Lihat sekarang',
    newVersion: 'Versi terbaru',
    hisVersion: 'Versi sebelumnya'
  },
  action: {
    listTime: 'Waktu operasi',
    list: 'Daftar operasi',
    listAccount: 'Akun operasi',
    listModule: 'Modul operasi',
    listContent: 'Konten operasi',
    taskAdd: 'Tambahkan tugas {name}',
    taskOpen: 'Mulai tugas {name}',
    taskCancel: 'Batalkan tugas {name}',
    taskStop: 'Jeda tugas {name}',
    taskRecover: 'Pulihkan tugas {name}',
    taskDownloadList: 'Unduh daftar tugas',
    taskDownloadName: 'Unduh daftar tugas {name}',
    taskDownloadDetail: 'Unduh detail tugas {name}',
    planAdd: 'Tambahkan rencana {name}',
    planCancel: 'Batalkan rencana {name}',
    planDownloadList: 'Unduh daftar rencana',
    planDownloadName: 'Unduh daftar rencana {name}',
    strategyAdd: 'Tambahkan kebijakan {name}',
    strategyEdit: 'Edit kebijakan {name}',
    strategyDelete: 'Hapus kebijakan {name}',
    callDetail: 'Unduh detail panggilan',
    blackListAdd: 'Tambahkan daftar hitam',
    blackListDelete: 'Hapus daftar hitam',
    blackListDownload: 'Unduh daftar hitam',
    shieldAdd: 'Tambahkan kebijakan Pemblokiran AI {name}',
    shieldEdit: 'Edit Kebijakan Pemblokiran AI {name}',
    shieldDelete: 'Hapus Kebijakan Pemblokiran AI {name}',
    shieldStop: 'Nonaktifkan Kebijakan Pemblokiran AI {name}',
    shieldOpen: 'Aktifkan Kebijakan Pemblokiran AI {name}',
    robotDownload: 'Unduh robot',
    robotEdit: 'Edit komentar {name}',
    robotAdd: 'Menambahkan skrip {name}',
    robotEditWord: 'Edit skrip {name}',
    robotApply: 'Menggunakan skrip {name}',
    robotDelete: 'Hapus skrip {name}',
    createTask: 'Membuat tugas {name}',
    createPlan: 'Membuat rencana {name}',
    callDelete: 'Batalkan panggilan ke {name}',
    crossLogin: 'Masuk melalui {name}',
    tip: 'Berikut ini adalah catatan operasi semua akun di perusahaan Anda, dan sistem mendukung untuk mencari catatan enam bulan terakhir',
    templateSave: 'Simpan',
    templateDel: 'Hapus',
    workflowAdd: 'Tambahan',
    workflowAddList: 'Tambahkan daftar',
    workflowCancel: 'Batal',
    versionSave: 'Simpan',
    versionPublish: 'Publikasi',
    versionActive: 'Aktif',
    versionArchive: 'Arsip',
    versionSaveDes: 'Simpan Deskripsi'
  },
  downloadCenter: {
    downloadCenter: 'Pusat Unduhan',
    progress: 'Mempersiapkan data',
    create: 'Pending, diperkirakan akan mulai diproses dalam waktu 5 menit.',
    rehandling: 'klik untuk memproses ulang',
    status5: 'Menulis data'
  },
  workFlow: {
    list: 'List',
    add: 'Template Alur Kerja Baru',
    workflowName: 'Nama Template Alur Kerja',
    placeholder: 'Silahkan masuk nama workflow',
    name: 'Nama template',
    dec: 'Gambaran',
    modifyUser: 'Operator',
    listNum: 'Jumlah daftar',
    checkTask: 'Lihat subtugas',
    addList: 'Tambahkan daftar',
    setTask: 'Settingan tugas workflow',
    inputName: 'Silahkan masukkan nama',
    inputDes: 'Silakan masukkan deskripsi',
    timeType: 'Metode pemicu',
    timeType1: 'Pemicu pada waktu yang ditentukan',
    timeType2: 'Berapa lama untuk memincu',
    timeTip1: 'Tentukan hari dan waktu untuk memicu',
    timeTip2: 'Berapa lama untuk memicu setelah tindakan yang terkait selesai',
    timeTitle: 'Waktu pemicu',
    timeTip3: 'Silakan pilih tanggal',
    timeTip4: 'Silakan pilih waktu',

    // TimeV2 Drawer
    timeV2Type: 'Metode Rilis',
    timeV2Type1: 'Rilis pada waktu yang ditentukan',
    timeV2Type2: 'Rilis setelah waktu tertentu',
    timeV2Tip1: 'Daftar tersebut akan tetap berada di node saat ini hingga mencapai waktu yang ditentukan, kemudian akan dirilis ke node berikutnya.',
    timeV2Tip2: 'Daftar akan tetap berada di node saat ini untuk waktu yang ditentukan, kemudian akan dirilis ke node berikutnya.',
    timeV2AbsoluteDateTitle: 'Tanggal',
    timeV2AbsoluteDateType1: 'Ketika daftar memasuki node saat ini',
    timeV2AbsoluteDateType2: 'Saat mengunggah daftar ke Workflow',
    timeV2AbsoluteTimeTitle: 'Waktu',
    timeV2AbsoluteTimeCurrent: 'Waktu saat ini',
    timeV2RelativeTimeTitle: 'Waktu tertentu',
    timeV2RelativeTimeHour: 'Jam',
    timeV2RelativeTimeMinute: 'Menit',
    dateTime: 'Custom Time',

    manualTitle1: 'Pengaturan pengingat web',
    manualTitle2: 'Waktu pengiriman pesan',
    manualTip: 'Berapa lama setelah tindakan baru selesai, dan  akan diingatkan di pusat pesan Panggilan',
    uslTitle1: 'Kondisi',
    uslTitle2: 'Jenis label',
    uslTitle3: 'Robot',
    uslTitle4: 'Label ',
    uslTitle5: 'Label acara',
    uslTitle6: 'Tambahkan kondisi "atau"',
    uslTitle7: 'Tambahkan label acara',
    splitterTitle1: 'Grup',
    splitterTitle2: 'Tambahkan grup',
    splitterTitle3: 'Data grup eksperimental harus sama dengan 100%',
    caTitle1: 'Menilai',
    caTitle2: 'Nama atrribut',
    caTitle3: 'Jenis data',
    caTitle4: 'Hubungan',
    caTitle5: 'Tambahkan penilaian "dan"',
    caTitle6: 'Angka',
    caTitle7: 'Karakter',
    caTitle8: 'Hari',
    caTitle9: 'Waktu',
    apiTip1: 'API  Action akan mengembalikan hasil eksekusi Tindakan lain. Silakan merujuk ke dokumentasi API yang disediakan oleh AIRudder untuk detailnya.',

    // OBCall Drawer
    ocTitle1: 'Interval pemutaran ulang',
    ocTitle2: 'Jumlah replay',
    ocTitle3: 'Daftar Strategi Manajemen',
    ocTitle4: 'Jumlah maksimum daftar per kelompok',
    ocTitle5: 'Waktu tunggu per kelompok',
    ocTip1: 'Kelola dan kirimkan panggilan keluar secara berkelompok',
    ocTip2: 'Jika jumlah daftar melebihi ambang batas yang ditetapkan, maka akan dibuat kelompok untuk segera dipanggil.',
    ocTip3: 'Jika waktu melebihi batas yang ditentukan, maka akan dibuat kelompok untuk segera dipanggil.',
    ocTitle6: 'Penghitungan Durasi Tugas Secara Otomatis',
    ocTitle7: 'Durasi Tugas Outbound',
    ocTip4: 'Rumus Perhitungan:',
    ocTip5: 'Durasi Tugas (menit)=interval redialing*jumlah redialing+30menit',
    ocTip6: 'Durasi Tugas (menit) =jumlah kontak*(jumlah redialing+1)/available concurrency+interval redialing*jumlah redialing+5menit',
    ocEditBtn: 'Editar',
    ocLimit: 'Por favor, introduzca 10～1440.',

    smsTitle1: 'Isi',
    smsTitle2: 'Pengiriman saluran',
    smsTitle3: 'Karakter SMS',
    smsTitle4: 'Ganti templatenya',
    smsTitle5: 'Pilih template SMS',
    smsTitle6: 'Daftar template SMS',
    smsTitle7: 'Pilih templat WhatsApp',
    smsTitle8: 'Daftar template WhatsApp',
    smsTitle9: 'Konfirmasi',
    smsTable1: 'Nama template',
    smsTable2: 'Isi',
    smsTable3: 'Saluran SMS',
    smsTable4: 'Jumlah karakter',
    pending: 'Sedang proses',
    taskType: 'Jenis tugas',
    checkLabel: 'Silakan pilih label besar atau label acara',
    include: 'Termasuk',
    exclude: 'Tidak termasuk',
    startswith: 'Dimulai dari',
    endwith: 'Berakhir dengan',
    cancelTip: 'Tugas tidak dapat dilanjutkan setelah pembatalan,Apa yakin melakukan pembatalan?',
    uliTip: 'Isi setidaknya label besar atau label acara',
    childPending: 'Pending',
    searchTip: 'Semua Workflow',
    childName: 'Nama Subtugas',
    callName: 'Nama Tugas',
    clickRateTip2: 'The denominator used for calculating the click-through rate is the total number of messages sent, not the number of messages successfully delivered. It is for reference only.',

    // PDS Drawer
    pdsTitle1: 'Grup Agen Manual',
    pdsTitle2: 'Interval panggilan agen',
    pdsTitle3: 'Jenis faktor slot',
    pdsTitle4: 'Otomatis',
    pdsTitle5: 'Manual',
    pdsTitle6: 'Maksimum Waktu Dering',
    pdsTitle7: 'Jumlah Minimum Entri dalam Daftar',
    pdsTitle8: 'Waktu Tunggu Tugas',
    pdsTitle9: 'Deteksi Pesan Suara',
    pdsTitle10: 'Waktu Deteksi Pesan Suara',
    pdsTip1: 'Jika waktu dering sebelum diangkat melebihi batas maksimal, maka sistem akan mengakhiri panggilan. (Waktu maksimum adalah 180 detik)',
    pdsTip2: 'Ketika jumlah daftar yang mengalir ke node lebih besar dari jumlah daftar minimum yang ditetapkan, maka tugas PDS akan terpicu secara langsung.',
    pdsTip3: 'Ketika waktu antara daftar pertama dan terakhir mengalir ke node melebihi batas waktu yang ditentukan, maka tugas PDS akan segera terpicu secara langsung.',
    pdsTip4: 'Setelah tugas selesai, QA akan dijalankan secara otomatis.',
    pdsTip5: 'Pesan suara akan terdeteksi, dan hanya panggilan non-pesan suara yang akan diberikan ke agen.',
    pdsTip6: 'Panjang maksimum deteksi pesan suara, dan setelah waktu yang ditetapkan, panggilan akan dianggap sebagai panggilan non-pesan suara.',
    pdsTip7: 'Interval Panggilan Ulang untuk Panggilan yang tidak terhubung',
    pdsTip8: 'Jumlah Maksimum Panggilan Ulang untuk Panggilan yang tidak terhubung',

    urlClickTitle: 'Waktu Kadaluarsa Tautan',
    apiTip: 'Tindakan API akan mengembalikan hasil eksekusi tindakan lain, metode permintaannya adalah POST. silakan merujuk ke dokumentasi API yang disediakan oleh AIRudder untuk detailnya.',
    humanAgentTitle: 'Hasil Dialog',
    overview: 'Ikhtisar data',
    dataTip1: 'Jumlah daftar yang ditunggu untuk diproses',
    dataTip2: 'Dalam pelaksanaan',
    dataTip3: 'Sudah selesai',
    dataTip4: 'Jumlah koneksi',
    dataTip5: 'Tingkat Capaian',
    dataTip6: 'Mengirim volume',
    dataTip7: 'Clik (dalam waktu 7 hari)',
    dataTip8: 'Click-throught rate (dalam waktu 7 hari)',
    blocked: 'Diblokir',
    labelTitle: 'Intention distribution',
    immediately: 'Memicu segera',
    obcallTitle: 'Upstream OB Call node',
    allDataView: 'Ikhtisar data',
    coTitle1: 'Pilih Node',
    coTitle2: 'Node',
    coTitle3: 'Atur Prioritas Label Niat',
    coTitle4: 'Setel kondisi pemisahan',
    coTitle5: 'Kondisi pemisahan',
    coTitle6: 'Tambahkan yang Baru Kondisi pemisahan',
    coTitle7: 'Node baru',
    coTip1: 'Silakan pilih node yang perlu diubah Label Intent sesuai prioritas.',
    coTip2: 'Silakan ubah prioritas sesuai dengan format "label besar" dan ">", misalnya: "C>A>B>D>H>E>G>F".',
    coTip3: 'Setiap kondisi shunt akan ditampilkan ketika node terhubung, dan kondisi shunt tidak dapat diulang.',
    chartTitle1: 'Distribusi label akhir',
    chartTitle2: 'Jumlah tindakan dalam daftar sirkulasi',
    chartTitle3: 'Sirkulasi daftar',
    chartSelect2: 'Semua saluran',
    chartSelect3: 'Semua tag terakhir',
    checkTitle1: 'Sudah dijalankan',
    checkTitle2: 'Hari',
    checkTitle3: 'Jam',
    checkTitle4: 'Menit',
    checkTitle5: 'Daftar periode waktu pengunggahan',
    actionViewTitle: 'Informasi Konfigurasi',
    dataTip9: 'Jumlah daftar yang diproses',
    isClick: 'Klik atau tidak dalam 7 hari',
    clickTime: 'Waktu klik',
    existName: 'Nama node sudah ada, silakan ubah dan coba lagi.',
    viewTip1: 'Jumlah Total Daftar yang diunggah ke tugas alur kerja dalam periode waktu penyaringan.',
    viewTip2: 'Jumlah Rata-rata Waktu Panggilan Panggilan Keluar selama peredaran dalam periode waktu penyaringan.',
    viewTip3: 'Rata-rata Jumlah Tindakan selama sirkulasi dalam periode waktu penyaringan. (Tidak termasuk tindakan API.)',
    viewTip4: 'Jumlah Total Waktu Panggilan Keluar dalam periode waktu penyaringan. (Tidak termasuk waktu pemanggilan ulang dalam aksi.)',
    viewTip5: 'Jumlah Total Panggilan Tercapai dalam periode waktu penyaringan.',
    viewTip6: 'Total Tingkat Jangkauan Panggilan Keluar dalam periode waktu penyaringan.',
    viewTip7: 'Total Jumlah SMS yang dikirim dalam periode waktu penyaringan.',
    viewTip8: 'Jumlah Total Klik Link Pendek SMS dalam 7 hari sejak dikirim dalam periode waktu penyaringan. (Hanya klik pertama kali yang akan dihitung.)',
    viewTip9: 'Rasio Klik-tayang dari Tautan Pendek SMS dalam waktu 7 hari sejak dikirim dalam periode waktu penyaringan.',
    viewTip10: 'Jumlah Total WhatsApp Terkirim dalam periode waktu penyaringan.',
    viewTip11: 'Jumlah Total Klik Tautan Pendek WhatsApp dalam 7 hari sejak dikirim dalam periode waktu penyaringan. (Hanya klik pertama kali yang akan dihitung.)',
    viewTip12: 'Rasio Klik-tayang dari Tautan Pendek dalam 7 hari sejak dikirim dalam periode waktu penyaringan.',
    viewTip13: 'Total Waktu Pemanggilan PDS dalam periode waktu penyaringan.',
    viewTip14: 'Jumlah Total Panggilan Tercapai PDS dalam periode waktu penyaringan.',
    viewTip15: 'Total Connection Rate PDS dalam periode waktu penyaringan.',
    viewTitle1: 'Distribusi Label Akhir dalam jangka waktu penyaringan.',
    viewTitle2: 'Jumlah tindakan yang diambil sebelum keluaran label akhir dalam periode waktu penyaringan. (Tidak termasuk tindakan API.)',
    viewTitle3: 'Pemisahan daftar antara tindakan dalam periode waktu penyaringan.',
    urlClickTitle1: 'SMS/WA Nodes',
    caTitle10: 'subkondisi',
    slotTip: 'Waktu pemicu ditentukan oleh slot yang dipilih, dimana daftar tersebut akan memasuki proses selanjutnya',
    slotTitle1: 'Node OB Call',
    slotTitle2: 'Slot',
    slotTitle3: 'Metode pemicu',
    slotSelect1: 'Pemicu tepat waktu',
    slotSelect2: 'Pemicu awal',
    slotSelect3: 'Pemicu penunda',
    nowDay: 'hari yang sama',
    howDay: 'hari ke- {name}',
    delTip:
      'Penghapusan node berikut akan memengaruhi data {name}, dan node lain yang telah mereferensikan node ini, hal ini dapat mengakibatkan workflow yang tidak normal. Harap segera mengubah data node yang terpengaruh setelah penghapusan.',
    saveTip: 'Terdeteksi bahwa informasi {name} belum tersimpan, harap simpan dan coba lagi',
    everyDay: 'Setiap Hari',
    ocsTitle1: 'Nama Putaran',
    ocsTitle2: 'Menindaklanjuti Putaran dan Label',
    ocsTitle3: 'Intensi / Event Labels',
    ocsTitle4: 'Putaran',
    ocsTitle5: 'Tambahkan Putaran Baru',
    ocsSort: 'Putaran diurut berdasarkan waktu',
    ocsError1: 'Putaran tindak lanjut terawal harus dipilih sebagai "Initial".',
    ocsError2: 'Periode panggilan {name} harus lebih besar dari Interval Panggilan Ulang *Jumlah Pemanggilan Ulang*',
    ocsError3: 'Waktu mulai {name} harus lebih lama dari waktu akhir {target}',
    ocsError4: 'Putaran dan label dari {name} dan {target} telah diduplikasi',
    ocsError5: 'Nama Putaran Sama / Sudah Terdaftar',
    ocsError6: 'Hanya satu putaran tindak lanjut yang dapat dipilih sebagai "Initial".',
    ocsError7: 'Hanya satu putaran "Seluruh" yang dapat ditindak lanjuti',
    obcallTitle2: 'Node PDS sebelumnya',
    close: 'Menutup',
    errorTip1: 'Tidak ada Node lain yang mengaju kepada Node saat ini',
    errorTip2: 'The set Trigger Time is too early or too late.',
    errorTip3: 'Tanggal pemicu yang diatur terlalu lama',
    errorTip4: 'Tidak ada jalan keluar yang diterapkan dimana kondisi pemisahan sama dengan lainnya',
    btn1: 'Pengecekan Mandiri',
    btn2: 'Publikasi',
    btn3: 'Settings',
    autoSave: 'Tersimpan Secara Otomatis',
    autoSave1: 'Penyimpanan Otomatis',
    autoSave2: 'Penyimpanan Otomatis Secara Berkala',
    min: 'Menit',
    on: 'Diaktifkan',
    off: 'Di non-aktifkan',
    commonSetting: 'Pengaturan Umum',
    nodeSetting: 'Pengaturan Node Batch',
    errTipTitle: 'Terdapat kesalahan pada {name}',
    errTipTip: 'Catatan: Tekan nama Node untuk menemukan Node yang bermasalah',
    againCheck: 'Pengecekan Ulang ',
    saveSuccess: 'Disimpan sebagai draft',
    checkSuccess: 'inspeksi mandiri lolos',
    apiTitle2: 'Node Sebelumnya',
    apiTitle3: 'Data kustom',
    apiTitle4: 'Nama Bidang',
    apiTitle5: 'Nilai',
    apiTitle6: 'Bidang baru',
    apiTip3: 'Tindakan API mengembalikan hasil eksekusi dari tindakan lain. Silakan lihat',
    apiTip4: 'Dokumen API yang disediakan oleh AIRudder untuk detail lebih lanjut.',
    apiTip5: 'Verifikasi',
    apiVerify: 'Terverifikasi',
    apiVerifySuccess: 'Verificado',
    apiVerifyFail: 'Verifikasi Gagal',
    apiVerifyWarn: 'Silakan verifikasi terlebih dahulu.',

    endtimeTip: 'Tugas workflow hanya akan berakhir pada waktu yang ditentukan, meskipun semua kontak saat ini telah dieksekusi.',
    autoFinishTip: 'Tugas workfloq akan berakhir secara otomatis ketika semua kontak dieksekusi untuk node terakhir.',
    pdsReason: 'Alasan Transfer',
    pdsReasonTip: 'Alasan transfer ditampilkan di halaman Panggilan Masuk untuk dilihat agen.',
    batchModify: 'Suntingan Batch',
    components: 'Komponen',
    addComponents: 'Komponen Baru',
    editComponents: 'Edit Komponen',
    saveNew: 'Simpan sebagai Komponen Baru',
    associationTemplate: 'Sama seperti Konfigurasi Templat',
    processConfig: 'Lihat Komponen',
    inputVersionDes: 'Masukkan deskripsi versi.',
    tempDesc: 'Deskripsi Templat',
    viewComponentExecutionDetails: 'Lihat Detail Komponen',
    delComponent: 'Hapus Komponen',
    delComponentTip: 'Apakah Anda yakin untuk menghapus komponen?',
    nohaveinputoroutput: 'Node Input atau Output tidak ada.',
    noComponent: 'Tidak ada komponen yang tersedia, silakan buat yang baru terlebih dahulu.',
    autoFinish: 'Akhiri secara Otomatis',
    delTips: 'Apakah Anda akan menghapus [{name}]?',
    tips: 'Catatan',
    pdsTitle11: 'Interval Nomor Kontak',
    pdsTip9: 'Interval panggilan antara nomor kontak yang berbeda dari satu kontak.',
    dnc: 'Strategi DNC',
    year: 'Tahun',
    holidayType1: 'Edarkan ketika tanggal sesuai dalam salah satu kategori berikut.',
    holidayType2: 'Edarkan ketika tanggal tidak termasuk dalam kategori berikut.',
    holidayTask1: 'Pemberhentian saat hari libur',
    holidayTask2: 'Diberhentikan pada',
    holidayTip:
      '"Pemberhentian saat hari libur" mengacu pada logika di mana tugas workflow, saat dimulainya eksekusi atau pada pukul 05:00 setiap harinya berdasarkan zona waktu akun, memeriksa apakah hari tersebut termasuk dalam kategori tanggal libur yang ditentukan untuk dilakukan penundaan. Jika iya, tugas workflow akan secara otomatis ditangguhkan selama satu hari hingga pukul 05:00 keesokan harinya ketika akan dievaluasi kembali.',
    mail1: 'Penerima',
    mail2: 'Pengirim',
    mail3: 'Daftar Template Email',
    mail4: 'Pilih Daftar Template Email',

    // timev2
    noVariable: 'Tanggal dan Waktu Tetap   ',
    allVariable: 'Variabel Tanggal dan Waktu',
    fixVariable: 'Tanggal Tetap dengan Waktu Variabel ',
    fixVariable2: 'Tanggal Variabel dengan Waktu Tetap',

    // waba template
    wabaAccount: 'Akun WABA',
    templateName: 'Nama Templat',
    templateContent: 'Konten Templat',
    contentView: 'Pratinjau',
    selectWABATemplate: 'Pilih templat WABA',
    wabaAccountAnd: 'Akun WABA dan daftar template',
    preview: 'Pratinjau',
    relateChatbot: 'Berhubungan dengan Chatbot',
    selectChatbot: 'Memilih Chatbot',
    robotVersion: 'Versi Bot',
    noRelateCb: 'Tidak Berhubungan dengan Chatbot',
    preOnline: 'Segera Diluncurka',
    online: 'Online / Aktif',
    noRelate: 'Tidak terkait',
    selectRobot: 'Tidak ada versi yang akan diluncurkan atau versi online dari bot yang dipilih.',
    selectVersion: 'Status versi tidak akan diluncurkan atau online.',

    // data overview
    wfTemplate: 'Template dan Versi Alur Kerja',
    callListTrend: 'Tren jumlah Kontak yang Dihubungi',
    allLabel: 'Semua Niat',
    labelDistriTrend: 'Tren Distribusi Niat',
    callDurationDistri: 'Distribusi Durasi Panggilan',
    callDurationTrend: 'Tren Distribusi Durasi Panggilan',
    ringDistribution: 'Tipe Dering',
    uploadListTrend: 'Tren Kontak yang Diunggah',
    hangUpDistribution: 'Tipe Penutupan Panggilan',
    transferTrend: 'Tren Tingkat Transfer',
    successNum: 'Jumlah Transfer yang Berhasil',
    dupListNum: 'Kontak Unik',
    cancelListNum: 'Kontak yang Dibatalkan',
    updateListNum: 'Kontak yang Diperbarui',
    createWFTaskNum: 'Tugas Alur Kerja Dibuat',
    runningWFTaskNum: 'Tugas Alur Kerja yang Sedang Berlangsung',
    theSameNum: ', setelah melakukan deduplikasi niat yang berbeda dari nomor telepon yang sama, hasil dengan prioritas tertinggi akan diambil.',
    redialListNumber: 'Kontak Dideduplikasi yang Dihubungi',
    deconnecting: 'Jumlah Kontak Terhubung yang Dideduplikasi',
    disconnection: 'Tingkat Jangkauan Deduplikasi',
    callNumbers: 'Panggilan yang Dihubungi',
    rounds: 'Panggilan Tersambung',
    connectionRate: 'Total Tingkat Panggilan yang Tercapai',
    connectedCalls: 'Rata-rata Panggilan',
    averageNumber: 'Rata-rata Percobaan untuk Panggilan',
    numberConnectedCalls: 'Rata-rata Percobaan untuk Setiap Panggilan Tersambung',
    averageCallDuration: 'Rata-rata Durasi Panggilan ',
    interactive: 'Rata-rata Jumlah Putaran Interaksi (s)',
    ringingDuration: 'Rata-rata Durasi Berdering (s)',
    turnLaborNumber: 'Percobaan untuk mentransfer ke agen',
    transferLaborRate: 'Tingkat Percobaan Transfer',
    successfulTransfers: 'Jumlah Transfer yang Berhasil',
    successRate: 'Tingkat Keberhasilan Transfer',
    shortMessage: 'Contacts Sent',
    singularName: 'Unique Contacts Sent',
    waShortMessage: 'Total Kontak yang Dikirimkan WhatsApp',
    waSingularName: 'Kontak Dideduplikasi yang Dikirimkan WhatsApp',
    day7Hits: 'Diklik dalam 7 hari setelah deduplikasi',
    clickThroughRate: 'Tingkat Klik Setelah Dideduplikasi.',
    transmissions: 'Total Terkirim',
    day7HitsTotal: 'Total yang Diklik dalam 7 Hari',
    clickRate: 'Tingkat Klik',
    averageTransmissions: 'Rata-rata Jumlah Pengiriman',
    messageSendingLists: 'Tren Kontak yang Dikirimkan',
    clickRateTrend: 'Tren Tingkat Klik',
    sendNum: 'Total Terkirim',
    click7: 'Diklik dalam 7 hari',
    pdsListNum: 'Kontak PDS',
    pdsDepListNum: 'Jumlah Kontak PDS yang Dideduplikasi',
    pdsTitle: 'Tren Kontak PDS',
    waSend: 'Total jumlah Kontak yang dikirimkan Template WA',
    waDupSend: 'Kontak Unik yang dikirim Template WA',
    allSend: 'Total Terkirim',
    averageSend: 'Rata-rata Jumlah Pengiriman',
    waSend2: 'Tren jumlah Template WA yang dikirim ke Kontak',
    waSendNumTrend: 'Tren Jumlah Pengiriman',
    includeUpload: 'Sertakan semua kontak yang diunggah dan ditambahkan',
    defaultCallNum:
      'Secara default, kontak akan dideduplikasi berdasarkan nomor telepon; apabila terdapat nomor telepon ganda dalam alur kerja yang berbeda, kontak tersebut juga akan dihapus duplikasinya.',
    defaultCallNum2: 'Secara default, data akan dideduplikasi berdasarkan dimensi unik yang dipilih. Duplikat dalam alur kerja yang berbeda dideduplikasi secara seragam.',
    cancelSuccess: 'Kontak Berhasil Dibatalkan',
    updateMessage: 'Kontak Berhasil Diperbarui',
    createSuccess: 'Tugas Alur Kerja Berhasil Dibuat',
    producingTasks: 'Tugas Alur Kerja yang Sedang Berlangsung',
    everyDay1: 'Perubahan harian dari semua Kontak yang diunggah dan ditambahkan, secara default dideduplikasi berdasarkan nomor telepon.',
    everyDay2: 'Perubahan harian untuk semua daftar yang telah diunggah dan ditambahkan. Aturan unik adalah melakukan deduplikasi sesuai dengan dimensi yang dipilih.',
    onlyT1: 'Hanya mendukung pengunduhan data offline T-1',
    allList: 'Jumlah daftar yang diunggah dalam alur kerja dan telah dihubungi setidaknya sekali.',
    atCallNum: 'Jumlah daftar yang sudah dihubungi setelah de-duplikasi berdasarkan nomor telepon.',
    atCallNum2: 'Jumlah daftar yang sudah dihubungi setelah de-duplikasi sesuai dimensi yang dipilih.',
    receivedAtLeast: 'Jumlah daftar yang tersambung dalam alur kerja yang diupload setelah de-duplikasi berdasarkan nomor telepon.',
    receivedAtLeast2: 'Jumlah daftar yang tersambung dalam alur kerja yang diupload setelah de-dupllikasi berdasarkan dimensi yang dipilih.',
    dereferenceRate: 'Perbandingan antara jumlah daftar yang tersambung dan daftar yang dihubungi, setelah penghapusan duplikasi.',
    missedRedials: 'Jumlah total semua daftar yang sudah dihubungi, tidak termasuk redial dalam putaran yang sama.',
    numberRounds: 'Jumlah total koneksi panggilan yang berhasil.',
    numberCalls: 'Perbandingan antara jumlah koneksi berhasil dan total panggilan.',
    averageRounds:
      'Rata-rata jumlah panggilan yang berhasil tersambung, tidak termasuk percobaan redial dalam putaran yang sama (tidak terpengaruh oleh robot dan filter yang dipilih di platform).',
    averageCallNum: 'Rata-rata jumlah panggilan setiap nomor telepon yang berhasil tersambung, termasuk percobaan redial dalam putaran yang sama (tidak terpengaruh oleh robot dan filter yang dipilih di platform).',
    connectedNum: 'Rata-rata jumlah panggilan yang sudah dihubungi, termasuk percobaan redial dalam putaran yang sama (tidak terpengaruh oleh robot dan filter yang dipilih di platform).',
    averageDuration: 'Rata-rata Durasi Panggilan untuk Panggilan yang Tercapai',
    averageActive: 'Rata-rata jumlah putaran interaksi aktif untuk panggilan yang tercapai',
    averageRing: 'Rata-rata durasi dering panggilan yang dihubungi, tidak termasuk percobaan redial dalam putaran yang sama.',
    numberAttempts: 'Jumlah percobaan untuk mentransfer panggilan ke agen, tidak termasuk percobaan redial dalam putaran yang sama.',
    attemptedTransfer: 'Perbandingan antara percobaan mentransfer ke agen dan jumlah koneksi yang berhasil.',
    successfulCallsTransferred: 'Jumlah transfer panggilan yang berhasil ke agen, tidak termasuk percobaan redial dalam putaran yang sama.',
    proportionCalls: 'Perbandingan antara jumlah transfer yang berhasil ke agen dan jumlah percobaan transfer.',
    dialedListChanges: 'Distribusi harian dari semua daftar yang dihubungi dan daftar yang dihubungi setelah penghapusan duplikasi.',
    theDeduplicationRule: 'Distribusi dari semua intention panggilan dan intention yang telah dihapus duplikasinya, berdasarkan nomor telepon dan prioritas intention.',
    theDeduplicationRule2: 'Distribusi dari semua intention panggilan dan intention yang telah dihapus duplikasinya, berdasarkan dimensi de-duplikasi dan prioritas intention yang dipilih.',
    dailyCall: 'Distribusi harian dari semua intention panggilan dan intention yang sudah dihapus duplikasinya, berdasarkan nomor telepon dan prioritas intention.',
    dailyCall2: 'Distribusi harian dari semua intention panggilan dan intention yang dihapus duplikasinya, berdasarkan dimensi de-duplikasi dan prioritas intention yang dipilih.',
    basedPhone: 'Distribusi harian data yang terduplikasi dan tidak terduplikasi untuk jumlah total panggilan yang dilakukan, panggilan yang tersambung, dan tingkat koneksi.',
    allConnectedCalls: 'Distribusi durasi panggilan dari semua panggilan yang dihubungi',
    durationDistribution: 'Distribusi harian durasi panggilan yang tersambung.',
    ringTypes: 'Distribusi Tipe Dering pada Semua Panggilan yang Dihubungi',
    hangUpTypes: 'Distribusi Tipe Penutupan Panggilan pada Semua Panggilan yang Dihubungi',
    transferTate: '已接通电话的转人工数、尝试转人工数、转人工率等的每日分布',
    sentMessages: 'Total Kontak yang Dikirimkan SMS',
    messagesSent: 'Total Kontak Terkirim setelah dideduplikasi berdasarkan nomor telepon',
    messagesSent2: 'Total jumlah daftar pesan yang dikirim setelah dideduplikasi berdasarkan dimensi yang dipilih',
    afterSending: 'Jumlah klik yang unik berdasarkan nomor telepon, hanya menghitung tautan pendek yang diklik dalam 7 hari setelah pengiriman',
    afterSending2: 'Jumlah klik yang unik berdasarkan dimensi yang dipilih, hanya menghitung tautan pendek yang diklik dalam 7 hari setelah pengiriman',
    rateSfter: 'Tingkat Klik setelah Dideduplikasi berdasarkan Nomor',
    shortChain: 'Hanya menghitung apakah tautan diklik dalam 7 hari setelah dikirim, dan hanya menghitung yang pertama jika diklik beberapa kali',
    averageNumberMessage: 'Rata-rata Jumlah Pengiriman',
    listSentmessages: 'Perubahan daftar pesan yang dikirim secara harian, unik berdasarkan nomor telepon',
    listSentmessages2: 'Perubahan daftar pesan yang dikirim secara harian, unik berdasarkan dimensi deduplikasi yang dipilih',
    clickRateSent: 'Perubahan tingkat klik harian pesan yang dikirim, data diperbarui pada hari T+1, unik berdasarkan nomor telepon',
    clickRateSent2: 'Perubahan tingkat klik pesan yang dikirim per hari, data diperbarui pada hari T+1, unik berdasarkan dimensi deduplikasi yang dipilih',
    nodesToEnter: 'Jumlah Kontak yang Memasuki Node PDS (lebih banyak data tersedia di platform AICC)',
    deduplicationLists: 'Jumlah Kontak  Dideduplikasi yang Memasuki Node PDS, dideduplikasi berdasarkan nomor telepon.',
    deduplicationLists2: 'Jumlah unik daftar masuk ke node PDS, unik berdasarkan dimensi deduplikasi yang dipilih',
    listOfPDS: 'Perubahan daftar masuk harian ke node PDS, unik berdasarkan nomor telepon',
    listOfPDS2: 'Perubahan daftar masuk harian ke node PDS, unik berdasarkan dimensi deduplikasi yang dipilih',
    WATemplateMessages: 'Perubahan dalam daftar yang telah menerima pesan Template WA setiap hari, unik berdasarkan nomor telepon',
    WATemplateMessages2: 'Perubahan dalam daftar yang telah menerima pesan Template WA setiap hari, unik berdasarkan dimensi deduplikasi yang dipilih',
    timesThatWA: 'Tren jumlah pesan Template WA yang dikirim per hari, dideduplikasi berdasarkan nomor telepon secara default.',
    timesThatWA2: 'Perubahan jumlah pesan Template WA yang dikirim per hari, unik berdasarkan dimensi deduplikasi yang dipilih',
    workflowTem: 'Template Alur Kerja',
    wfDrawerTip: 'The latest available date can be up to two months from the current date.',
    realtime: 'Real-time',
    offline: 'Offline',
    sendNumTip: 'Number of requested messages to be sent, which does not represent the number of successful deliveries.',
    aveTip: 'Average number of requested message sends per unique phone number.',
    sendedNum: 'Pesan Berhasil Terkirim',
    sendedNumTip: 'Number of messages successfully sent by the carrier. In cases where the message exceeds the character limit, it may be split into 2 messages, and will be counted as 2 messages.',
    sendSuc: 'Successfully sent messages ',
    sendedNumTip2: 'Number of times the operator successfully performs a sending after receiving a request',
    uniqSendSuc: 'Successful unique deliveries',
    uniqSendedNumTip: 'Berapa kali permintaan berhasil dikirim ke operator setelah de-emphasis berdasarkan nomor telepon.',
    uniqSendedNumTip2: 'Berapa kali permintaan berhasil dikirim ke operator setelah de-emphasis oleh dimensi de-emphasis yang dipilih.',
    clickRateTip: 'Percentage of clicks on short links within 7 days of sending, relative to the total number of successfully sent messages (counting multiple clicks as 1).',
    uniqClickRateTip: 'Percentage of clicks on short links within 7 days of sending, relative to the total number of unique successfully sent messages (counting multiple clicks as 1).',

    // 发布配置
    confirmTime: 'Harap konfirmasi bahwa template alur kerja ini membutuhkan durasi waktu minimal',
    noMore62: 'Durasi waktu maksimum tidak boleh melebihi 62 hari.',
    minTime: 'Durasi Waktu Minimum',
    // calendar
    delSelect: 'Hapus Item Terpilih',
    batchAddHoliday: 'Tambah Hari Libur Kustom secara massal',
    uploadCustom: 'Impor Hari Libur Kustom',
    check: 'Validasi',
    title2: 'Unggah File yang Telah Selesai',
    fileTypeError: 'Format file tidak sesuai, silakan coba lagi.',
    max2M: 'Silakan unggah file yang lebih kecil dari 2MB.',
    pleaseUpload: 'Silakan unggah file terlebih dahulu.',
    dlError: 'Unduh dan Lihat Alasan Kegagalan',
    allData: 'Total Data',
    calendarUpload: 'Hari libur telah diunggah.',
    calendar5s: 'Halaman akan otomatis tertutup dalam 5 detik.',
    delTip2: 'Hari libur Kustom mungkin direferensikan dalam template alur kerja. Harap berhati-hati saat menghapusnya.',

    labelLevel: 'Prioritas Intention',
    labelCombination: 'Kombinasi Intention',
    effectCallDefinition: 'Definisi Panggilan Efektif',
    effectCallDefinition2: 'Dimensi dari Definisi Panggilan Efektif',
    effectCallDefinition3: 'Durasi Minimal Panggilan yang Efektif',
    labelLevelTip: 'Catatan: Anda bisa mengubah prioritas intention dengan menggeser posisi; intention yang ditempatkan lebih awal akan memiliki prioritas lebih tinggi. Perubahan pada bagian ini akan memengaruhi semua data intention historis yang telah dihapus duplikasinya.',
    dimensionTip: 'Catatan: Setelah memilih dimensi de-duplikasi yang berbeda, Anda bisa melihat data de-duplikasi yang berbeda di dashboard.',
    labelCombinationTip: 'Catatan: Setelah menggabungkan intention yang berbeda, Anda bisa melihat proporsi intention secara gabungan di dashboard.',
    effectCallDefinitionTip: 'Catatan: Silakan hubungi kami untuk mengonfigurasi durasi panggilan efektif dan periode efektif. Hanya hasil konfigurasi yang ditampilkan di sini.',
    validCallToalTip: 'Jumlah dari semua panggilan yang tersambung secara efektif. Penjelasan mengenai panggilan efektif dapat ditemukan dalam "Pengaturan Kustom".',
    validRepeatToalTip: 'Jumlah koneksi yang efektif setelah de-duplikasi berdasarkan nomor telepon.',
    validRepeatToalTip2: 'Jumlah total koneksi efektif setelah penghilangan penekanan sesuai dengan dimensi penghilangan penekanan yang dipilih',
    validCallRateTip: 'Perbandingan antara total koneksi efektif dan total panggilan.',
    validRepeatRateTip: 'Perbandingan antara jumlah koneksi efektif yang tersambung dan daftar yang dihubungi, setelah penghapusan duplikasi.'
  },
  ca: {
    action: 'Parameter tindakan',
    list: 'Daftar parameter',
    system: 'Parameter sistem',
    diy: 'parameter kustom',
    common: 'Parameter umum',
    fun: 'Parameter operasional',
    funTip: 'Deskripsi fungsi',
    bj1: 'Dari...sampai...',
    bj2: 'Kosong',
    bj3: 'Tidak Kosong',
    bj4: 'Apakah hari libur atau bukan',
    max: 'Nilai Maksimum',
    min: 'Nilai Minimum'
  },
  desc: {
    date_sub_desc: 'Kurangi parameter tanggal untuk mendapatkan selisih hari'
  },
  channel: {
    tableTitle: 'Daftar template',
    name: 'Nomor Hotline',
    content: 'Informasi',
    str: 'Karakter informasi',
    num: 'Jumlah informasi',
    channel: 'Pengiriman saluran',
    conventional: 'Robot biasa',
    diy: 'Menyesuaikan Robot IVR ',
    change: 'Mengubah nada',
    record: 'Nada',
    speed: 'Kecepatan siaran',
    contentTip:
      '1. Jika ada tautan dalam konten pesan teks, saat akan dikirim itu akan diubah menjadi tautan pendek khusus, dan klik pengguna dapat dihitung; 2. Jika ada konten dengan gaya {xxx} di konten SMS, itu adalah variabel dalam template, dan konten yang berbeda akan dikirim ke pengguna yang berbeda sesuai dengan konten variabel yang Anda unggah.',
    strTip: 'Berikut ini adalah karakter yang diharapkan, dan jumlah karakter akan bervariasi tergantung pada konten sebenarnya dari tautan atau variabel dalam pesan.',
    sendTime: 'Waktu pengiriman',
    templateName: 'Template SMS'
  },
  eventLabel: {
    label: 'Label acara',
    attr: 'Label properti',
    drawerTitle: 'Deskripsi label acara',
    all: 'Semua informasi',
    more: 'Dan sebagainya'
  },
  checkDetail: {
    ringTime: 'Waktu Berdering',
    totalNumberCalls: 'Total Panggilan',
    callHistory: 'Log Panggilan',
    questionNumber: 'Nomor Urut Pertanyaan',
    problemDesc: 'Deskripsi Masalah',
    topic: 'Jenis Pertanyaan',
    whetherAnswer: 'Jawab atau Tidak',
    answer: 'Jawaban',
    variable: 'Variable',
    checkResults: 'Hasil Percobaan',
    checkDialogue: 'Cek Dialog',
    previousDetail: 'Details Sebelum',
    nextDetail: 'Details Setelah',
    history: 'Catatan History',
    know: 'Mengetahui',
    clickDesc: 'Klik untuk melihat detail untuk mempelajari lebih lanjut tentang panggilan',
    whether: 'Pertanyaan apa',
    multiple: 'Milih pertanyaan',
    open: 'Pertanyaan terbuka'
  },
  report: {
    titleTip: '(Hanya data yang dihasilkan setelah {name} yang dapat dilihat)',
    time: 'Rentang waktu',
    compared: 'Membandingkan dengan',
    deduplication: 'Diduplikasi atau Tidak',
    listNum: 'Jumlah total daftar',
    connectNum: 'Jumlah panggilan terhubung',
    connectRate: 'Tingkat Capaian',
    duration: 'Durasi panggilan rata-rata (detik)',
    business: 'Data bisnis',
    robot: 'Performa robot',
    turn: 'Terhubung atau tidak',
    beforeOverdue: '~ T-1',
    todayOverdue: 'Tanggal jatuh tempo',
    overdue: 'T+1 ~',
    labelRate: 'Tingkat label',
    month: 'Berdasarkan bulan',
    week: 'Berdasarkan minggu',
    onWeek: 'Week {name}',
    unduplicated: 'Digandakan',
    duplicate: 'Tidak ada deduplikasi',
    labelTip1: 'Jumlah total daftar yang diunggah selama periode statistik',
    labelTip2: 'Jumlah total daftar yang telah terhubung selama periode statistik',
    labelTip3: 'Tingkat koneksi yang terhubung pada saat periode skrining',
    labelTip4: 'Durasi panggilan rata-rata dari daftar yang terhubung selama periode statistik',
    type: 'Tipe'
  },
  version: {
    viewarchive: 'Lihat Arsip',
    archive: 'Arsip',
    id: 'nomor versi',
    description: 'deskripsi versi',
    templateId: 'ID pola',
    save1: 'Mengulang dan menerbitkan ',
    save2: 'Menerbitkan sebagai versi terbaru',
    save3: 'Mengaktifkan versi ini',
    save4: 'Nonaktifkan versi ini',
    saveTip: 'Ketika diaktifkan, Versi ini akan menggantikan versi yang saat ini sedang di aktifkan',
    draft: 'Draft',
    time: 'waktu arsip',
    re: 'tidak arsip',
    user: 'diarsipkan oleh',
    pdsQA: 'QA Otomatis',
    success: 'berhasil mengaktifkan',
    resuccess: 'berhasil tidak mengarsipkan',
    delsuccess: 'berhasil mengarsipkan',
    savesuccess: 'berhasil menyimpan',
    pop: 'Versi ini sudah di rilis. Draft versi akan di buat berdasarkan versi ini',
    version: 'versi',
    listTime: 'daftar waktu unggah'
  },
  experience: {
    robotNameTip: 'Harap masukan nama Bot.',
    shareLog: 'Bagikan Riwayat',
    shareBatch: 'Bagikan',
    playAudio: 'Putar Rekaman',
    experience: 'Coba Sekarang',
    share: 'Bagikan Sekarang',
    step1: 'Harap isi informasi dasar',
    step2: 'Atur Skenario dan Bot',
    step3: 'Atur Variabel',
    step4: 'Selesai',
    shareNmae: 'Bagikan Nama',
    language: 'Bahasa',
    validity: 'Masa Berlaku',
    callCountry: 'Negara Panggilan',
    shareTime: 'Bagikan Waktu',
    zh: 'Mandarin',
    en: 'Inggris',
    ba: 'Bahasa Indonesia',
    copyLink: 'Salin Tautan',
    qrcode: 'Lihat Kode QR',
    view: 'Lihat Data',
    disable: 'Setel sebagai tidak valid',
    linkLog: 'Tautan Pencarian Riwayat',
    customerLog: 'Catatan Pengalaman Pelanggan',
    check: 'Lihat Detail',
    logTime: 'Waktu Pencarian',
    browser: 'Pencarian',
    device: 'Perangkat',
    city: 'Kota',
    isExperience: 'Coba',
    shareTitle: 'Bagi',
    dec: 'Deskripsi Bot',
    enterShare: 'Yakin dibagikan',
    noVar: 'Tidak ada variabel yang perlu dikonfigurasi untuk bot ini',
    callNumber: 'Nomor Telefon',
    waitCall: 'Harap menunggu, panggilan akan segera disambungkan.',
    reCall: 'Menelefon kembali',
    activeSuccess: 'Berhasil ditetapkan sebagai tidak valid.',
    ruleName: 'Silakan masukkan Nama Pembagian.',
    ruleLanguage: 'Silakan pilih bahasa.',
    ruleTime: 'Silakan pilih Periode Validitas.',
    ruleCounty: 'Silakan pilih Negara Panggilan.',
    ruleDesc: 'Silakan masukkan Deskripsi Bot.',
    fail: 'Tautan saat ini sudah tidak valid, silakan hubungi pembagi.',
    sceneName: 'Nama Skenario.',
    sceneDesc: 'Deskripsi Skenario',
    canModify: 'Dapat diubah oleh Pelanggan',
    calltitle: 'Isi Informasi',
    successTitle: 'Berhasil Dikirim.',
    wait: 'Harap tunggu',
    waitNext: 'Panggilan akan segera disambungkan.',
    cut: 'Membagi bot dari skenario',
    cutTip: 'Jika Anda perlu menggabungkan beberapa bot menjadi satu skenario untuk dibagikan, silakan tarik dan lepaskan bot ke skenario yang sama.',
    codeTip2: 'Kode QR akan kedaluwarsa pada tanggal {time}.',
    codeTip1: 'Pindai untuk Mencoba Kecerdasan VoiceBot.',
    downCode: 'Unduh kode QR',
    tips: 'Apakah Anda yakin ingin menonaktifkannya?',
    tempDesc: 'Template Deskripsi',
    sceneRepeat: 'Nama skenario sudah ada.',
    callTime: 'Waktu Panggilan',
    otherRob: 'Bot Lainnya',
    failTime: 'Waktu Kedaluwarsa',
    gender: 'Jenis kelamin'
  },
  // 私有化版本相关功能
  v_privatization: {
    templateContent: 'Isi Templat',
    insertUrl: 'Sisipkan Target URL',
    templatePlaceholder: 'Harap masukkan nama template.',
    templateContentPlaceholder: 'Masukkan konten template.',
    channelPlaceholder: 'Silakan pilih saluran pengirim.',
    SMSTemplate: 'Templat SMS',
    WhatsAppTemplate: 'Templat WhatsApp',
    createSMSTemplate: 'Templat SMS Baru',
    editSMSTemplate: 'Edit Templat SMS',
    createWhatsAppTemplate: 'Templat WhatsApp Baru',
    editWhatsAppTemplate: 'Edit Templat WhatsApp',
    SMSTip:
      'Deskripsi: Setelah memasukkan URL Asli, klik "Masukkan Target URL" untuk memasukkan tautan ke dalam SMS saat mengirim. URL Target adalah tautan pendek yang dikirim ke kontak, di mana klik tautan dihitung. Jumlah kata dan jumlah pesan SMS adalah hasil perkiraan. Untuk hasil yang akurat, silahkan tes sendiri.',
    WhatsAPPTip:
      'Catatan: Setelah memasukkan URL Asli, klik "Masukkan Target URL" untuk memasukkan tautan ke dalam pesan saat mengirim. URL Target adalah tautan pendek yang dikirim ke kontak, di mana klik tautan dihitung. Jumlah kata dan jumlah pesan SMS adalah hasil perkiraan. Untuk hasil yang akurat, silahkan tes sendiri.',
    hangUpMessage: 'Pesan Penutup',
    hangUpMessageAdd: 'Pesan penutup baru',
    hangUpMessageEdit: 'Edit pesan penutup',
    hangUpMessageTip: 'Jika Strategi Pengiriman Pesan Multi-putaran diaktifkan, maka pada putaran ini, pesan tidak akan dikirim ke kontak yang akan dipanggil pada putaran berikutnya.',
    callResult: 'Hasil Panggilan',
    messageType: 'Jenis Pesan',
    messageTemplate: 'Templat Pesan',
    messageChannel: 'Saluran Pesan',
    messageNumber: 'Jumlah Pesan',
    messageTip:
      '① Klik pengguna pada tautan pendek di SMS akan dihitung; ② {xxx} adalah variabel dalam template SMS, di mana berbagai teks akan dikirim ke kontak yang berbeda berdasarkan konten yang diunggah.',
    channel: 'Saluran',
    platformPlaceholder: 'Silakan pilih Platform',
    addMessage: 'Templat Pesan Baru',
    activeStatusTip: 'Apakah Anda yakin ingin mengaktifkan templat?',
    inactiveStatusTip: 'Apakah Anda yakin ingin menonaktifkan templat?',
    activeHangUpStatusTip: 'Apakah Anda yakin ingin menonaktifkan pesan penutup?',
    inactiveHangUpStatusTip: 'Apakah Anda yakin ingin menonaktifkan pesan penutup?',
    operateSuccess: 'Berhasil',
    licenseValidityPeriod: 'Masa Berlaku Lisensi',
    maxCallConcurrency: 'Konkurensi Panggilan Maksimum',
    LicenseTip: 'Pengingat Masa Berlaku Lisensi',
    licenseWillExpired: 'Pengingat: Lisensi Anda akan kedaluwarsa dalam {day} hari, setelah itu Anda tidak dapat mengaksesnya lagi. Segera hubungi AIRUDDER untuk memperbarui lisensi.',
    licenseExpired:
      'Pengingat: Lisensi Anda telah kedaluwarsa selama {expired} hari. Anda tidak akan dapat menggunakannya kecuali Anda memperbaruinya dalam {last} hari. Silakan hubungi AIRUDDER untuk memperbarui lisensi.',
    licenseInvalid: 'Lisensi telah kedaluwarsa. Harap perbarui.'
  },
  calendar: {
    title: 'Manajemen Kalender',
    lab1: 'Daftar Hari Libur',
    lab2: 'Distribusi Kalender',
    type: 'Klasifikasi',
    dayName: 'Hari Libur',
    addDay: 'Tambahkan Hari Libur Kustom',
    day1: 'Hari Kerja',
    day2: 'Hari Libur',
    day3: 'Hari Libur Resmi',
    day4: 'Hari Libur Kustom',
    tip: 'Logika penilaian: Ketika daftar masuk ke simpul ini, atau pada pukul 05:00 setiap harinya berdasarkan zona waktu akun, akan dievaluasi apakah daftar tersebut harus dilepaskan pada hari itu. Jika tidak memenuhi syarat untuk dilepaskan, akan dievaluasi kembali pada pukul 05:00 keesokan harinya. Proses ini akan terus berlanjut hingga daftar memenuhi kondisi pelepasan untuk hari tersebut, memungkinkan daftar tersebut melanjutkan ke langkah-langkah berikutnya.',
    r1: 'Gunakan Bot asli',
    r2: 'Pilih Bot'
  },
  inbound: {
    screeningConditions: 'Filter',
    talkedByRobots: 'Jumlah Panggilan',
    talkingByRobots: 'Panggilan Robot yang Sedang Berlangsung',
    stRate: 'Tingkat Penerimaan Agen',
    stTip: 'successful transfers to human agents / total calls',
    raTalkTime: 'Rata-rata Durasi Panggilan Robot ',
    raTalkRounds: 'Rata-rata Putaran Interaksi Robot ',
    tbAgents: 'Panggilan Agen',
    tbTip: 'successful transfers to human agents',
    tbAgents2: 'Panggilan Agen yang Sedang Berlangsung',
    tttRate: 'Tingkat Transfer yang Dilakukan',
    tttTip: 'attempted transfers to human agents / total calls',
    tatTime: 'Rata-Rata Total Durasi Panggilan ',
    tickets: 'Tiket yang Dibuat',
    graphics: 'Tabel',
    prceProcess: 'Persentase Panggilan Bot berdasarkan Proses',
    calls: 'Panggilan dengan Percakapan',
    rate: 'Persentase',
    allProcess: 'Semua Proses',
    rlDistribution: 'Distribusi Tujuan',
    dtReason: 'Distribusi Penyebab Transfer ke Agen',
    dtNodes: 'Distribusi Titik Transfer',
    kwnlPoint: 'Tingkat Hit Pengetahuan',
    hitValid: 'Hit Pengetahuan yang Valid',
    useRate: 'Tingkat Pemanfaatan Pengetahuan',
    knRoundNum: 'Hit Pengetahuan dalam Putaran Percakapan',
    allRoundNum: 'Total Putaran Percakapan',
    validPer: 'Persentase Pengetahuan yang Valid',
    top10: '10 Pengetahuan Paling Populer',
    top20: '20 Pengetahuan Paling Tidak Populer',
    knName: 'Pengetahuan',
    mainProcess: 'Proses Utama',
    hotline: 'Hotline',
    inbound: 'Masuk',
    inAndOut: 'Masuk + Keluar',
    userSatis: 'Skor Kepuasan Pelanggan',
    star1: '1 poin',
    star2: '2 poin',
    star3: '3 poin',
    star4: '4 poin',
    star5: '5 poin',
    satisRate: 'Skor Kepuasan Pelanggan',
    userNum: 'Kontak',
    rotTip2:
      'Persentase panggilan valid bila kontak tidak menelepon dua kali. Statistik ini adalah tingkat resolusi kontak pertama bot per hari kalender. Jika jangka waktu yang dipilih melebihi satu hari, pembilangnya adalah jumlah panggilan efektif tanpa panggilan kedua untuk setiap hari dalam periode waktu yang dipilih.',
    rotTip: 'The ratio of valid calls without a second call on the same day to the total number of valid calls',
    ctuTip: 'The number of unique callers based on the incoming phone numbers received',
    etuTip: 'The total number of unique users, based on their incoming phone numbers, who had at least one valid interaction with the chatbot during the calls.',
    totalEffectCallNum: 'Total Panggilan Aktif',
    noSecondCallNum: 'Panggilan Efektif dari Kontak tanpa Panggilan Masuk Kedua',
    oneTimeRate: 'Tingkat Resolusi Kontak Pertama',
    taiTip: 'successful transfers to human agents / attempted transfers to human agents',
    rjTip: 'The percentage of evaluated calls out of the total calls where customer satisfaction evaluations were triggered',
    reCallNum: 'Jumlah Panggilan Berulang',
    reCNTip: 'Jumlah panggilan yang bukan merupakan panggilan pertama per hari, adalah "Jumlah Panggilan" - "Kontak Masuk".',
    rcrTip: 'Persentase panggilan yang diulang/total panggilan',
    rcrTip2: 'Persentase panggilan masuk berulang sebagai proporsi dari total panggilan per hari kalender. Jika periode waktu yang difilter melebihi 1 hari, persentase tersebut menunjukkan nilai rata-rata harian.',
    taTip: 'Persentase panggilan yang berhasil ditransfer ke agen dari total percobaan transfer ke agen.',
    ctTip: 'Jumlah panggilan masuk yang diduplikasi berdasarkan nomor masuk.',
    euTip: 'Jumlah panggilan efektif yang diduplikasi berdasarkan nomor masuk.',
    rcTip:
      'Rasio panggilan berulang terhadap jumlah total panggilan. Statistik ini mewakili tingkat panggilan berulang harian. Jika jangka waktu yang dipilih melebihi satu hari, maka akan menjadi nilai rata-rata setiap hari.',
    orTip:
      'Persentase panggilan valid bila kontak tidak menelepon dua kali. Statistik ini adalah tingkat resolusi kontak pertama bot per hari kalender. Jika jangka waktu yang dipilih melebihi satu hari, maka akan menjadi nilai rata-rata setiap hari.',
    orTip2:
      'Presentase panggilan valid ketika kontak tidak melakukan dua kali panggilan(Ini adalah data T-1 hari, yang mewakili tingkat penyelesaian kontak pertama untuk setiap hari dalam kalender.)',
    oneRateTip: 'Ini adalah data T-1 hari',
    realtimeData: 'Data Waktu Nyata',
    offlineData: 'Data Luar Talian',
    robotSatis: 'Tingkat Kepuasan Robot',
    rsTip: 'The percentage of calls rated as "satisfied" among all evaluated calls',
    robotSatisTip: 'Persentase panggilan yang mendapat skor 3 atau lebih tinggi di semua panggilan yang dinilai.',
    robotJudgeNum: 'Jumlah Evaluasi Bot',
    robotSatisNum: 'Jumlah Kepuasan Bot',
    thisDayNoBack: 'Panggilan Valid tanpa Upaya Panggilan Kedua pada Hari yang Sama',
    thisDayMax: 'Konkurensi Maksimum untuk Hari Ini',
    showAndDlField: 'Bidang untuk Ditampilkan dan Diunduh',
    untriggered: 'Tidak dipicu',
    unrated: 'Belum diberi peringkat',
    robotSatisRate: 'Skor Kepuasan Bot',
    indicators: 'Indicators',
    labelPriority: 'Prioritas Niat',
    dlData: 'Unduh',
    offlineTip: 'Data untuk modul ini dibuat dengan penundaan satu hari (T+1). Oleh karena itu, jika Anda memilih hari ini sebagai periode waktu, tidak akan ada data yang ditampilkan.',
    slotTip1: 'Catatan: Slot NER dikonfigurasi dalam alur robot. Semua slot robot ditampilkan di sini.',
    slotTip2:
      '1. Silakan atur apakah akan menampilkan slot saat terkena atau tidak sesuai kebutuhan Anda. Jika Anda centang "Tampilkan", slot yang terkena dan nilai slot akan ditampilkan dalam detail panggilan;',
    slotTip3: '2. Silakan atur apakah slot tertentu dapat digunakan sebagai item filter sesuai kebutuhan Anda;',
    slotTip4:
      '3. Silakan atur apakah slot tertentu dapat digunakan sebagai header tabel Excel dari daftar unduhan setelah terkena sesuai kebutuhan Anda, dan slot dan nilai slot lain yang tidak diatur akan ditempatkan secara seragam di bawah field header tabel NER slots.',
    diffTime: 'Waktu Perbandingan',
    minValidInteractives: 'Putaran Manusia-Bot',
    minValidInteractives2: 'Min. Putaran Manusia-Bot',
    robotTimeLeast: 'Min. Durasi Panggilan Bot yang Valid',
    effectCallSetTip: 'Catatan: Ubah definisi panggilan efektif dan lihat di dashboard data.',
    orders: 'Total Tiket',
    xjqsOrders1: 'Total Struk Palsu',
    xjqsOrders2: 'Struk Palsu Unik Harian',
    xjqsOrders3: 'Total Struk Palsu Unik',
    hangAINum: 'Panggilan Tutup Telepon AI',
    hangUserNum: 'Panggilan Tutup Telepon Pengguna',
    hangeAgentNum: 'Panggilan Tutup Telepon Agen',
    tbAgentsTip1: 'Jumlah Panggilan yang Sedang Berlangsung dengan Bot',
    tbAgentsTip2: 'Jumlah Panggilan yang Sedang Berlangsung dengan Agen',
    callTimeTip: 'Periode saat ini dan periode sebelumnya untuk menghitung data periode ke periode ditentukan oleh rentang waktu yang dipilih, baik satu hari atau rentang beberapa hari. Misalnya, jika “Hari Ini” dipilih, periode saat ini adalah hari ini dan periode sebelumnya adalah kemarin. Jika “3 Hari Terakhir” dipilih, periode saat ini adalah 3 hari terakhir dan periode sebelumnya adalah 3 hari sebelumnya.',
    tbAgentsTip: 'Panggilan yang Berhasil Ditransfer ke Agen',
    stRateTip: 'Panggilan yang Berhasil Ditransfer ke Agen/ Total Panggilan',
    tttRateTip: 'Panggilan yang Dicoba untuk Ditransfer/ Total Panggilan',
    toArtiRateTip: 'Panggilan yang Berhasil Ditransfer ke Agen/Panggilan yang Dicoba untuk Ditransfer',
    attAgentNumTip: 'Jumlah Panggilan yang Dicoba untuk Ditransfer dari Total Panggilan',
    validCallNumTip: 'Lihat "Pengaturan Kustom" untuk definisi Panggilan Efektif.',
    tatTimeTip: 'Rata-rata durasi panggilan untuk seluruh panggilan, termasuk bagian bot dan agen.',
    raTalkTimeTip: 'Rata-rata Durasi Panggilan untuk Bagian Bot',
    agentAvgDurationTip: 'Rata-rata Durasi Panggilan untuk Bagian Agen',
    validCallDesTip: 'Distribusi Harian Total Panggilan dan Panggilan Efektif (lihat definisi Panggilan Efektif di "Pengaturan Kustom")',
    everydayMaxTip: 'Puncak Konkurensi Harian pada Level Menit (data T-1, tidak tersedia untuk hari ini)',
    raTalkRoundsTip: 'Rata-rata Jumlah Pergantian Interaksi Bot-Pengguna',
    robotJudgeRateTip: 'Persentase Panggilan yang Dinilai dari Semua Panggilan dengan Evaluasi Kepuasan yang Diberikan.',
    robotSatisAvgScoreTip: 'Rata-rata skor kepuasan untuk semua panggilan (dihitung dari panggilan dengan penilaian aktual).',
    robotOneTimeRateTip: 'Persentase harian panggilan efektif tanpa panggilan berikutnya dari pengguna; untuk periode lebih dari satu hari, ini adalah jumlah panggilan efektif harian tanpa panggilan kedua. Lihat "Pengaturan Kustom" untuk definisi panggilan efektif.',
    robotOneTimeRateTip2: 'Persentase harian panggilan efektif tanpa panggilan berikutnya dari pengguna, seperti yang didefinisikan dalam "Pengaturan Kustom" (data T-1, tidak tersedia untuk hari ini).',
    prceProcessTip: 'Proporsi volume panggilan untuk setiap proses utama dalam total volume panggilan.',
    noCurDaySeeTip: 'Data T-1, tidak tersedia untuk hari ini.',
    intentAccuracyTip: 'Akurasi pengenalan niat bot (data T-1, tidak tersedia untuk hari ini).',
    newUserNumTip: 'Jumlah Penelepon Pertama Kali',
    oldUserNumTip: 'Jumlah Penelepon Berulang',
    validPerTip: 'Jumlah dan persentase poin pengetahuan efektif yang berhasil dicapai dari semua poin pengetahuan, yang menunjukkan efektivitas desain basis pengetahuan dalam menjawab pertanyaan pengguna.',
    kwnlPointTip: 'Distribusi harian dari putaran pengetahuan yang berhasil tercapai, total putaran, dan rasionya, yang menunjukkan cakupan basis pengetahuan terhadap pertanyaan pengguna.',
    top10_tip: '10 poin pengetahuan yang paling banyak ditanyakan terdaftar dalam urutan menurun berdasarkan frekuensi tercapai (putaran dialog).',
    top20_tip: 'Daftar Poin Pengetahuan yang Tidak Pernah Tercapai',
    minValidRoundTip: 'Selama percakapan manusia-bot, pengguna telah berbicara setidaknya sekali, termasuk menggunakan keypad telepon.',
    isFalseSign: 'Tanda Tangan Palsu atau Tidak',
    falseSignOD: 'Tanda Terima Palsu',
    realCall: 'Panggilan Real-time',
    vaildUser: 'Pengguna yang valid',
    ticketType: 'Jenis Tiket'
  },
  chatbot: {
    reason: '原因',
    indicator: '仪表盘',
    graphics: '数据可视化',
    social: '社媒',
    allSocial: '所有社媒',
    allCountry: '所有国家',
    sessionData: '会话数据',
    resTime: '响应时长',
    today: '今日',
    yesterday: '昨日',
    robotSessionNum: '机器人会话数',
    satisRate: '满意度',
    likeFWRate: '服务满意度',
    robotEnd: '机器人结束',
    botQueueTimeout: '机器人排队超时',
    userEnd: '用户结束',
    agentEnd: '人工结束',
    robotChatCondition: '机器人对话情况',
    sessionEndReason: '会话结束原因',
    intentionDistribution: '服务流程触发分布',
    identifyDistribution: '识别分布',
    knowledgeBase: '知识库',
    intention: '意图',
    chat: '闲聊',
    unrecognized: '未识别',
    robotCondition: '机器人识别情况',
    top10: 'Top10热门知识',
    words: '话术',
    knowledgePoints: '知识点',
    triggerRate: '触发量/比例',
    star1: '1星',
    starVal: '{num}星',
    userNum: '用户数',
    sessionNum: '会话数',
    repeatRate: '重复进线率',
    repeatRate2: '当日重复进线率',
    userNews: '用户消息数',
    robotTimes: '机器人响应时长',
    robotBFNum: '实时机器人并发量',
    artificialNum: '转人工会话数',
    robotWaitNum: '机器人排队数',
    artificialWaitNum: '人工排队数',
    artificialCalls: '人工响应时长',
    callsAvg: '平均响应时长',
    sessionAvg: '平均会话时长',
    robotSessionAvg: '机器人平均会话时长',
    artificialRate: '转人工率',
    robotEndNum: '机器人结束会话数',
    userEndNum: '用户结束会话数',
    artificialEndNum: '坐席结束会话数',
    roundAvg: '平均对话轮次',
    robotLikes: '机器人满意度',
    JSRate: '拒识率',
    knowledgeNum: '知识数',
    intentionNum: '意图数',
    chatNum: '闲聊数',
    unrecognizedNum: '未识别数',
    recognizedNum: '直接识别率',
    recommendRate: '推荐问触发率',
    vsday: '前1日',
    vsday7: '前7日',
    detailExport: '详细数据导出',
    total: '总计',
    date: '日期',
    country: '国家',
    channel: '渠道',
    download: '下载',
    userLikes: '用户满意度',
    coreData: '核心业务数据',
    likeRate: '满意率',
    evaluateRate: '评价率',
    serverLikeRate: '服务满意率',
    robotLikeRate: '机器人满意率',
    robotEvaluateRate: '机器人评价率',
    artificialSuccessRate: '转人工成功率',
    serverEvaluateRate: '服务评价率',
    todayMaxBFNum: '当日最大并发量',
    likeNum: '满意数',
    firstSolutionRate: '首解率',
    artificialOkSessions: '转人工成功会话数',
    todayZXYDNum: '当日咨询运单数',
    ZXYDNum24: '24h无二次咨询运单数',
    userLikeNum: '满意用户数',
    evalUsers: '评价用户数',
    robotEvaluates: '机器人评价数',
    robotLikeNum: '机器人满意数',
    userServerEvaluates: '人工服务评价数',
    userServerEvaluateRate: '人工服务评价率',
    userServerLikeRate: '人工服务满意率',
    userServerLikes: '人工服务满意数',
    artificialFailNum: '转人工失败会话数',
    artificialFailEvaluates: '转人工失败评价数',
    artificialFailLikes: '转人工失败满意数',
    artificialFailEvaluateRate: '转人工失败评价率',
    artificialLikeRate: '转人工满意率',
    artificialFailLikeRate: '转人工失败满意率',
    all: '全部',
    likeRateAnalysis: '满意度分析',
    serverEffect: '服务效果',
    dislikeDistribution: '不满意原因分布',
    sessionType: '会话类型',
    robotSession: '机器人会话',
    artificialSuccess: '转人工成功',
    artificialFail: '转人工失败',
    artificialSession: '转人工会话',
    botServerSession: '机器人服务会话',
    artificialOkSession: '转人工成功会话',
    artificialFailSession: '转人工失败会话',
    evaluates: '评价数',
    channelMerge: '渠道聚合',
    current_users_total: '当前处理会话数',
    current_robot_wait: '当前机器人排队会话数',
    current_agent_sessions: '当前坐席处理会话数',
    current_robot_sessions: '当前机器人处理会话数',
    current_agent_wait_sessions: '当前坐席排队会话数',
    users: '用户数',
    sessions: '会话数',
    rr_income: '当日重复进线率',
    user_messages: '用户消息数',
    robot_res_time: '机器人响应时长',
    transfers: '转人工会话数',
    transfer_rate: '转人工率',
    transfers_succeed_rate: '转人工成功率',
    avg_sessions_time: '平均会话总时长',
    avg_robot_time: '平均机器人会话时长',
    avg_agent_time: '平均人工会话时长',
    // avg_trans_time: '转人工等待时长',
    max_qps: '当日最大并发量',
    Knowledge: '知识库',
    All: '意图',
    NoRecognize: '未识别',
    user_close: '用户结束',
    robot_close: '机器人结束',
    agent_close: '人工结束',
    ascending: '从低到高排序',
    descending: '从高到低排序',
    etip1: '将您关注的指标拖入相关预览框中',
    etip2: '会话结束原因',
    etip3: '数据指标已添加完成',
    etip4: '暂无更多指标',
    etip5: '图表已添加完成',
    etip6: '暂无更多图表',
    etip7: '当前页面编辑信息未保存,是否保存？',
    title1: '实时指标',
    title2: '当天累计指标',
    title3: '数据图表',
    title4: '机器人识别分布',
    title5: '会话结束原因',
    title6: '趋势图',
    title7: '机器人流程分布',
    avg_trans_time: '平均转人工等待时长',
    botSessionNum: '机器人会话数',
    agentSessions: '转人工会话数',
    csat1: '1星',
    csat2: '2星',
    csat3: '3星',
    csat4: '4星',
    csat5: '5星',
    res_time: '总平均响应时长',
    agent_res_time: '人工响应时长',
    bot_res_time: '机器人响应时长',
    session_time: '总平均会话时长',
    agent_session_time: '人工会话时长',
    robot_session_time: '机器人会话时长',
    totals: 'Total',
    marketing: 'Marketing',
    service: 'Service',
    utility: 'Utility',
    authentication: 'Authentication',

    historical: {
      title: '数据指标',
      title1: '用户进线频繁时段',
      title2: '用户和会话数趋势',
      title3: '当日重复进线率',
      title4: '会话类型趋势',
      title5: '转人工率',
      title6: '平均响应时长',
      title7: '平均会话时长',
      title8: '会话结束原因',
      title9: '首解率',
      title10: '当日最大并发量',
      title11: '服务分析',
      title12: '服务流程分布',
      title13: '服务效果',
      title14: '用户满意率',
      title15: '不满意原因分布',
      title16: '不满意关键流程分布',
      title17: '转人工流程原因',
      title18: 'WABA计费模块',
      title19: 'WABA Conversation Count',
      overall: '整体',
      bot: '机器人',
      agent: '人工',
      tip: {
        title1: '查询时段里小时内的平均用户数和会话数<br/>用户数：进线的用户去重总数<br/>会话数：用户创建的会话总数',
        title2: '用户数：进线的用户去重总数<br/>会话数：用户创建的会话总数',
        title3: '单日单用户的非首次会话总数/所有会话总数',
        title4:
          '总会话数: 所有会话<br/>机器人会话数：即流程中未触发转人工即结束的<br/>转人工会话数：即流程中触发了转人工的；按转人工结果可进一步分为：人工服务会话、转人工失败会话<br/>转人工失败会话数：即流程中触发了转人工的、转人工失败的会话',
        title5: '转人工率：转人工的会话数/会话数<br/>转人工成功率：转人工成功的会话数/转人工会话数',
        title6: '总平均响应时长: 一段会话，平均单次回复运行时长<br/>机器人响应时长: 机器人服务的会话，平均单次回复运行时长<br/>人工响应时长: 人工服务的会话，平均单次回复运行时长',
        title7:
          '总平均会话时长: 用户与机器人和人工（若转人工）互动的平均总时间<br/>机器人会话时长: 机器人会话 （无发起转人工），用户与机器人互动的总时间<br/>人工会话时长: 人工会话 （发起转人工），用户与人工互动的总时间',
        title8:
          '机器人结束：仅由机器人服务的会话（即未转人工）<br/>转人工失败：因转人工失败而结束的会话<br/>人工结束：即有人工成功接管后，由坐席结束的会话<br/>用户结束：暂不支持<br/>机器人排队超时：限制机器人并发的情况下，排队超时',
        title9: '查询该运单后,24小时内无重复进线的运单比例',
        title10: '当日最大的机器人并发量，并发占用时间为用户进线->转人工/会话结束',
        title11: '',
        title12: '机器人触发的流程分布',
        title13: '服务效果分析，包括评价率和满意率',
        title14: '',
        title15: '用户不满意原因',
        title16: '用户不满意的关键流程',
        title17: '触发转人工的机器人流程'
      }
    },

    story: {
      story_PlaceOrder: '寄快递',
      story_DeliveryAsk: '快件催查',
      story_Package_returned: '快件退回',
      story_Change_Information: '修改信息',
      story_AskShippingCost2: '查运费',
      sotry_AskEstimatedTimeBeforeDelivery: '查时效',
      story_AskBranch: '查网点',
      story_AskDelivery_Range: '查配送范围',
      story_PackageIssues: '快件问题',
      story_AskFranchise: '加盟咨询',
      story_TransferArtificial: '人工服务',
      story_Complaint: '投诉'
    },
    story2: {
      story_AskEstimatedTimeBeforeDelivery: '查时效', // 未翻译
      story_entrance: '菜单服务',
      all_TransferArtificial: '人工服务',
      story_AskIFHelp: '是否需要其他帮助',
      story_IfSolved: '问题是否已解决',
      story_AskJob: '求职咨询',
      story_ConfirmIntent: '确认需要服务类型（加盟/求职）',
      story_InquiryServices: '确认查询业务（网点/范围）',
      story_PackageClaim: '索赔',
      story_ServiceSelection: '服务选择（催件登记/转人工）',
      story_PlaceOrder: '寄快递',
      story_Package_returned: '快件退回',
      story_Change_Information: '修改信息',
      story_AskShippingCost2: '查运费',
      story_AskBranch: '查网点',
      story_AskDelivery_Range: '查配送范围',
      story_PackageIssues: '快件问题',
      story_AskFranchise: '加盟咨询',
      story_Complaint: '投诉',
      story_OtherService: '其他服务',
      story_Create_Order: '创建工单',
      story_Create_Order_POD: '创建工单',
      story_DeliveryAsk: '快件催查',
      story_Query_another_logistic: '快件催查',
      story_TransferArtificial: '人工服务',
      story_Transfer: '人工服务'
    },

    userID: '用户ID',
    userName: '用户昵称',
    localTime: '当地时间',
    sessionStartTime: '会话开始时间',
    robotServiceTime: '机器人服务时长',
    agentServiceTime: '人工服务时长',
    botServiceTime: '机器人服务时长',
    agentSessionDuration: '人工服务时长',
    botService: '机器人服务',
    agentSession: '人工服务',
    waybill: '合法运单号',
    sessionEndTime: '会话结束时间',
    sessionDur: '会话时长',
    serverStatus: '服务状态',
    robotServer: '机器人服务',
    userServer: '人工服务',
    noLikeReason: '不满意原因',
    sessionDetail: '会话详情',
    prevOne: '上一个',
    nextOne: '下一个',
    cannelTitle: '添加消息渠道，与您的用户高效沟通。',
    noChannel: '无授权渠道',
    addCannnel: '添加渠道',
    delete: '删除',
    edit: '编辑',
    detail: '详情',
    duplicate: '复制',
    action: '操作',
    addTime: '添加时间',
    updateTime: '更新时间',
    updater: '更新人',
    accountName: '账号名称',
    dialogueLink: '对话链接',
    last: '上一步',
    next: '下一步',
    next2: '已拥有，下一步',
    authorize: '授权账号',
    stepVal: '步骤{num}',
    viberPanel: 'Viber Bot控制面板',
    almost: '即将完成',
    addBind: '新增绑定',
    editBind: '修改绑定',
    effectChannel: '生效渠道',
    robotId: '机器人ID',
    versionId: '版本ID',
    channelName: '渠道名称',
    channelId: '渠道ID',
    updateAccount: '更新账号',
    seeRecord: '查看记录',
    save: '保存',
    cancel: '取消',
    submit: '提交',
    remark: '备注',
    facebookBtn: '关联Facebook',
    connectChannel: '授权渠道',
    newInf: '新增信息',
    editInf: '编辑信息',
    name: '名称',
    company: '公司',
    proxy: '代理',
    reqName: '请求名称',
    tmplName: '模版名称',
    saveDraft: '保存为草稿',
    saveSubmit: '保存并提交',
    wbTmplStatus: {
      draft: '草稿',
      rejected: '审核不通过',
      submitted: '审核中',
      paused: '已暂停',
      disabled: '已禁用',
      approved: '审核通过'
    },
    unknown: '未知',
    broadcastList: '广播列表',
    broadcastName: '广播名称',
    sendAccount: '发送账号',
    broadcastTmpl: '广播模版',
    newBroadcast: '新建广播',
    broadcastDetail: '广播详情',
    broadcastData: '广播数据',
    taskList: '任务列表',
    tmplInf: '模版信息',
    copyTask: '复制任务',
    broadcastTime: '广播时间',
    selectTmpl: '选择模版',
    upContacts: '上传名单',
    setTime: '设定时间',
    language: 'Language',
    category: 'Category',
    styletype: 'Type',
    taskStatus: {
      failed: '发送失败',
      wait: '未发送',
      sending: '发送中',
      sent: '已发送',
      delivery: '已送达',
      read: '已阅读',
      replied: '已回复'
    },
    taskNum: '名单量',
    sentNum: '发送量',
    deliveredNum: '送达量',
    readNum: '阅读量',
    replies: '回复量',
    failNum: '失败量',
    deliveredRate: '送达率',
    readRate: '阅读率',
    replyRate: '回复率',
    sendNow: '立即发送',
    sendSchedule: '预约发送',
    sendTime: '发送时间',
    account: '账号',
    downloadTmpl: '下载模版',
    reupload: '重新上传',
    sendResults: '发送结果',
    broadcastStatus: '广播状态',
    userAccount: '用户账号',
    userOptOut: '用户退订',
    batchAdd: '批量添加',
    seatMark: '坐席标注',
    addNameLs: '添加名单',
    moreDetails: '更多详情',
    optOutStartTime: 'Opt-out开始日期',
    optOutEndTime: 'Opt-out结束日期',
    remove: '移除',
    quality: 'Quality Rating',
    currentLimit: 'Messaging Limit',
    tip: {
      userNum: '进线的用户去重总数',
      sessionNum: '用户创建的会话总数',
      repeatRate: '单日单用户的非首次会话总数/所有会话总数',
      userNews: '用户发送的总消息数',
      robotTimes: '机器人服务的会话，平均单次回复运行时长',
      robotBFNum: '当前与机器人会话的客户总量',
      artificialNum: '由机器人转接人工的会话数',
      artificialRate: '转人工的会话数/会话数',
      robotWaitNum: '排队等待机器人服务的会话数',
      artificialWaitNum: '排队等待人工服务的会话数',
      artificialCalls: '人工服务的会话，平均单次回复运行时长',
      callsAvg: '平均单次回复运行时长',
      sessionAvg: '所有会话的平均分钟数',
      robotEndNum: '由机器人告知会话结束',
      userEndNum: '由用户行为结束对话（按钮/策略）',
      artificialEndNum: '由坐席结束对话',
      roundAvg: '机器人与用户平均在每个会话中对话的轮次',
      JSRate: '机器人未识别的用户消息比例',
      recognizedNum: '机器人识别出用户意图的消息数',
      recommendRate: '触发机器人推荐问，用户意图澄清的消息数',
      knowledgeNum: '机器人回复中，命中知识库的数量',
      intentionNum: '机器人回复中，命中意图识别的数量',
      chatNum: '机器人回复中，命中闲聊的数量',
      unrecognizedNum: '机器人未识别用户发送信息的数量',
      robotSessionAvg: '由机器人服务的会话的平均会话时长',
      firstSolutionRate: '查询该运单后，24小时内无重复进线的运单比例',
      todayMaxBFNum: '查询日期的机器人最大并发量',
      serverLikeRate: '所有会话中，满意的会话/有评价的会话',
      serverEvaluateRate: '有评价的会话/所有会话',
      artificialSuccessRate: '转人工成功的会话数/转人工会话数',
      robotLikeRate: '机器人服务会话中，满意的会话/有评价的会话。',
      artificialLikeRate: '机器人转人工的会话中，满意的会话/有评价的会话。',
      userServerLikeRate: '人工服务的会话中，满意的会话/有评价的会话。',
      artificialFailLikeRate: '转人工失败的会话中，满意的会话/有评价的会话。',
      channelMerge: '开启后将展示所有渠道的聚合数据，关闭查看各渠道明细数据。',
      plsDayVal: '最多可查询{num}天',
      plsFutureDayVal: '请选择未来{num}天内的时间',
      noChannel: '您可以在我们的平台上连接所有的业务消息账户，我们称之为渠道。让我们一起来添加一个渠道吧。',
      facebookTitle: '我们需要一些权限来管理您的主页消息，以便能收到和回复Messenger消息与评论',
      facebookStep1: '基于Facebook封号规则，请在经常登录Facebook账号的电脑上进行授权绑定',
      facebookStep1_des: '授权前，请确保您必须是Facebook粉丝主页的管理员',
      facebookStep2: '若提示错误，请检查网络是否正常，剧新页面后重试',
      facebookStep3: '登录您的Facebook帐户并勾选您想要授权管理的粉丝主页',
      insTitle: '请确保您拥有Instagram专业账号',
      insStep1_1: '您需要将Instagram个人账号转换为专业账号才能连接至AI Rudder',
      insStep1_2: '如需帮助，请参考:',
      insStep1_3: '在Instagram上设置专业账号',
      whatsappStep1: '未注册WhatsApp的手机号，且该手机号可接收短信或电话',
      whatsappStep2: '经过认证的Facebook Business Manager',
      lineTitle: '请在同一Provides下创建Line的Messaging API channel, 然后提供以下信息完成Line账号添加',
      botTokenProvide: '请提供在 {name} 处获取到Bot Token完成授权',
      authorizeSuccess: '授权成功',
      authorizeFail: '授权失败',
      delChannel: '如果您解除此渠道授权，您将无法再通过此渠道与联系人互动。您确定要一起解除授权吗？',
      repeatChannel: '您已在平台授权此账号，请重新选择',
      plsTelMe: '请联系我们获得帮助',
      plsScopeFacebook: '请授权Facebook账号',
      upload: '允许{types}类型的文件上传, 且文件的大小不超过{size}.',
      uploadSize: '文件的大小不能超过{size}',
      tmplNameReg: '请输入小写字母数字或下划线',
      noLikePlsClick: '没有合适的？点击{name}',
      broadcastSaveErr: '表格内第{n}行用户信息有误，请重新上传',
      broadcastSaveRepeat: '第{n}行用户信息重复，请查看后重新上传',
      broadcastSaveOverload: '上传的用户超过单次广播数量上限，请重新上传',
      broadcastDelTask: '删除后，任务不可恢复，确认要删除吗？',
      broadcastLimtNum: '当前账号{name}，发送限制为：{n}，超出限制的会发送失败。',
      broadcastDLTitle: '下载本广播名单样例',
      broadcastDLTip1: '请填写每个用户的变量信息，缺失的将填写默认值。',
      broadcastDLTip2: '仅允许上传xlsx/csv类型的文件，且不超过1MB。单次任务至多上传3000人。',
      broadcastReplies: '发送成功后，24h内有回复消息的用户数量',
      removeOptOut: '移出后，用户将收到广播消息，请确认移出。',
      optOutTerm: '说明：用户90天内将不会收到广播消息',
      batchTelUp: '支持批量上传，号码间需要换行<br>示例：<br>+628122218888888<br>+628122217777777',
      avg_sessions_time: '用户进线时间到会话结束时间',
      avg_robot_time: '机器人开始时间到发起转人工时间',
      avg_agent_time: '成功转人工时间到人工结束对话时间',
      avg_trans_time: '发起转人工时间到成功转人工时间',
      current_users_total: '当前正在处理或等待处理、未关闭的会话数',
      current_robot_wait: '当前等待机器人处理的会话数',
      current_agent_sessions: '当前坐席正在处理、未关闭的会话数',
      current_robot_sessions: '当前机器人正在处理、 未关闭的会话数',
      current_agent_wait_sessions: '当前发起转人工未成功转接、正在排队的会话数',
      downloadTip: '下载超过5000条的通话记录将被分成多个文件，是否继续?',
      selectUser: '只有当用户点击button或引用回复模板时，才会调起该机器人。如需对整个渠道生效，请在机器人管理配置渠道机器人。'
    },
    wbTmplTip: {
      header: '添加标题或选择此Header所使用的媒体类型',
      body: '如果要添加自定义变量，请在{{}}中添加一个变量，不要加空格。',
      body2: '如：{{name}}',
      footer: '在模板消息底部添加一行简短的文本',
      buttons: '添加快捷回复或CTA按钮',
      buttonLimit: 'Buttons不能有变量、换行符或表情符号',
      variables: '请确保不要包含任何实际的用户或客户信息，并且在示例中只提供示例内容。',
      sample: 'Sample content for {name}',
      del: '删除模板后，30天内不可申请同名模板，请确认是否删除？',
      variableRepeat: '变量名不能重复',
      optOutBtn: '用户退订入口，如用户点击90天内将不会收到广播'
    }
  },
  teamInbox: {
    // 新增
    all_chat: '所有',
    my_chat: '我的',
    manuanling: '未分配',
    broadcast: '广播',
    bot: '机器人',
    closed: '关闭',
    broadcastinfo: '广播会话',
    botinfo: '机器人会话',
    broadcastType: '未开启',
    botType: 'bot',
    manuanlingType: '未分配',
    manualedType: '与{user}交谈中',
    closedType: '已关闭',
    jiesu: '结束会话',
    jieg: '接管会话',
    userInfo: '客户信息',
    chatTitle: '坐席会话',
    manualedAMType: '转交',
    duihua: '对话中',
    changeUser: '确认将对话转交给:',
    tips: '提示',
    yes: '是',
    no: '否',
    noType: '暂不支持展示该类型消息',
    start: '{name}开启了新的会话',
    close: '{name}关闭了会话',
    take_over: '{name}接管了会话',
    hand_over: '{name}将会话转交{toName}',
    msgSet: '消息设置'
  },
  security: {
    session: 'Manajemen Batas Waktu Sesuai Sesi',
    defaultSession: 'Batas Waktu Sesuai Sesi Default',
    userInLogin: 'Setelah login selama ',
    autoLogout: 'pengguna akan otomatis keluar. (Rentang valid: 1-24 jam)',
    idleSessionTimeout: 'Batas Waktu Sesi Diam',
    userIn: 'Tidak ada aktivitas dalam ',
    noRun: 'maka akun akan keluar secara otomatis. (Rentang valid: 5 menit hingga 24 jam)',
    pl1: 'Silakan masukkan bilangan bulat antara {num1} dan {num2}.',
    accountLock: 'Manajemen Pemblokiran Akun',
    maxError: 'Jumlah Maksimum Gagal Login Sebelum Pemblokiran Akun',
    lockTime: 'Durasi Pemblokiran',
    lockTipBase: '(Setelah akun terblokir, akan keluar secara otomatis, dan upaya login tidak diizinkan selama periode pemblokiran.)',
    counter: 'Interval Pengaturan Ulang Penghitung',
    counterTip: '(Setelah interval waktu ini, penghitung kegagalan login akan diatur ulang, dan penghitungan dimulai dari 0.)',
    couMag: 'Manajemen Login Bersamaan',
    oneAccount: 'Satu akun dapat login secara bersamaan pada ',
    bro: ' perangkat/peramban.',
    forMag: 'Manajemen Penonaktifan Akun',
    ifMag: 'Jika akun tidak login dalam jangka waktu yang valid, upaya login selanjutnya akan dinonaktifkan.',
    nearMag: 'Notifikasi Login Terakhir',
    loginSuccess: 'Saat berhasil login, waktu login terakhir akan ditampilkan.',
    accountTrue: 'Batas Waktu Kedaluwarsa Login',
    saveTip: 'Modifikasi pengaturan keamanan akun akan mempengaruhi perilaku akun dan semua akun subnya. Apakah Anda yakin ingin melanjutkan dengan modifikasi?',
    loginLockTip: 'Nama pengguna atau kata sandi salah. Jika dimasukkan dengan salah {errorNum} kali lagi, pengguna akan terblokir selama {errorMin} menit.',
    forTip: 'Akun pengguna ini telah dinonaktifkan. Silakan hubungi administrator atau tim dukungan kami untuk bantuan.',
    lockTip: 'Akun pengguna saat ini terkunci. Silakan coba lagi setelah {errorMin} menit.',
    loginSuccess2: 'Login Berhasil',
    last: 'Informasi Login Terakhir',
    moreTip: 'Maaf, frekuensi akses telah melebihi batas. Silakan coba lagi nanti.',
    lockTip2: 'Akun Anda telah terkunci. Silakan coba lagi.',
    userStatus: 'Status Akun',
    visitStatus: 'Status Akses'
  }
}



// WEBPACK FOOTER //
// ./src/lang/ba.js